webpackJsonp([114276838955818],{

/***/ 320:
/***/ (function(module, exports) {

	module.exports = {"data":{"allSoetChapterNode":{"edges":[{"node":{"chapterId":9,"slug":"introduction","prevPath":"/","path":"/chapter/introduction/","nextPath":"/chapter/evolving-europe/","childPath":"/chapter/introduction/article/about-report/","title":"Introduction","titleNumber":"01"}},{"node":{"chapterId":10,"slug":"evolving-europe","prevPath":"/chapter/introduction/","path":"/chapter/evolving-europe/","nextPath":"/chapter/talent/","childPath":"/chapter/evolving-europe/article/its-been-busy-year-european-tech/","title":"Evolving Europe","titleNumber":"02"}},{"node":{"chapterId":11,"slug":"talent","prevPath":"/chapter/evolving-europe/","path":"/chapter/talent/","nextPath":"/chapter/community/","childPath":"/chapter/talent/article/strong-pipeline-world-class-talent/","title":"Talent","titleNumber":"03"}},{"node":{"chapterId":12,"slug":"community","prevPath":"/chapter/talent/","path":"/chapter/community/","nextPath":"/chapter/capital-flows/","childPath":"/chapter/community/article/growing-and-highly-engaged-tech-communities/","title":"Community","titleNumber":"04"}},{"node":{"chapterId":13,"slug":"capital-flows","prevPath":"/chapter/community/","path":"/chapter/capital-flows/","nextPath":"/chapter/deep-tech/","childPath":"/chapter/capital-flows/article/another-record-year-european-tech-investment/","title":"Capital Flows","titleNumber":"05"}},{"node":{"chapterId":14,"slug":"deep-tech","prevPath":"/chapter/capital-flows/","path":"/chapter/deep-tech/","nextPath":"/chapter/corporate/","childPath":"/chapter/deep-tech/article/european-deep-tech-seize-global-opportunities/","title":"Deep Tech","titleNumber":"06"}},{"node":{"chapterId":15,"slug":"corporate","prevPath":"/chapter/deep-tech/","path":"/chapter/corporate/","nextPath":"/chapter/regulation/","childPath":"/chapter/corporate/article/european-tech-forge-ties-traditional-industry/","title":"Corporate","titleNumber":"07"}},{"node":{"chapterId":16,"slug":"regulation","prevPath":"/chapter/corporate/","path":"/chapter/regulation/","nextPath":"/chapter/success-stories-exits/","childPath":"/chapter/regulation/article/regulation-viewed-barrier-scaling-european-tech/","title":"Regulation","titleNumber":"08"}},{"node":{"chapterId":17,"slug":"success-stories-exits","prevPath":"/chapter/regulation/","path":"/chapter/success-stories-exits/","nextPath":"/chapter/mythbusting/","childPath":"/chapter/success-stories-exits/article/europes-billion-dollar-success-stories/","title":"Success Stories & Exits","titleNumber":"09"}},{"node":{"chapterId":18,"slug":"mythbusting","prevPath":"/chapter/success-stories-exits/","path":"/chapter/mythbusting/","nextPath":"/chapter/whats-next/","childPath":"/chapter/mythbusting/article/european-venture-delivers-returns/","title":"Mythbusting","titleNumber":"10"}},{"node":{"chapterId":19,"slug":"whats-next","prevPath":"/chapter/mythbusting/","path":"/chapter/whats-next/","nextPath":"/chapter/appendix/","childPath":"/chapter/whats-next/article/predictions-european-tech-2018/","title":"What's Next?","titleNumber":"11"}},{"node":{"chapterId":20,"slug":"appendix","prevPath":"/chapter/whats-next/","path":"/chapter/appendix/","nextPath":"/chapter/acknowledgements/","childPath":"/chapter/appendix/article/survey-respondents/","title":"Appendix","titleNumber":"12"}},{"node":{"chapterId":21,"slug":"acknowledgements","prevPath":"/chapter/appendix/","path":"/chapter/acknowledgements/","nextPath":"","childPath":"/chapter/acknowledgements/article/contributors/","title":"Acknowledgements","titleNumber":"13"}}]},"allSoetArticleNode":{"edges":[{"node":{"prevPath":"/chapter/introduction/","path":"/chapter/introduction/article/about-report/","nextPath":"/chapter/introduction/article/how-use-site/","parentPath":"/chapter/introduction/","chapterId":9}},{"node":{"prevPath":"/chapter/introduction/article/about-report/","path":"/chapter/introduction/article/how-use-site/","nextPath":"/chapter/introduction/article/about-atomico/","parentPath":"/chapter/introduction/","chapterId":9}},{"node":{"prevPath":"/chapter/introduction/article/how-use-site/","path":"/chapter/introduction/article/about-atomico/","nextPath":"/chapter/introduction/article/about-slush/","parentPath":"/chapter/introduction/","chapterId":9}},{"node":{"prevPath":"/chapter/introduction/article/about-atomico/","path":"/chapter/introduction/article/about-slush/","nextPath":"/chapter/introduction/article/data-partners/","parentPath":"/chapter/introduction/","chapterId":9}},{"node":{"prevPath":"/chapter/introduction/article/about-slush/","path":"/chapter/introduction/article/data-partners/","nextPath":"/chapter/introduction/article/thought-leaders/","parentPath":"/chapter/introduction/","chapterId":9}},{"node":{"prevPath":"/chapter/introduction/article/data-partners/","path":"/chapter/introduction/article/thought-leaders/","nextPath":"/chapter/introduction/article/distribution-partners/","parentPath":"/chapter/introduction/","chapterId":9}},{"node":{"prevPath":"/chapter/introduction/article/thought-leaders/","path":"/chapter/introduction/article/distribution-partners/","nextPath":"/chapter/introduction/article/word-from-orrick/","parentPath":"/chapter/introduction/","chapterId":9}},{"node":{"prevPath":"/chapter/introduction/article/distribution-partners/","path":"/chapter/introduction/article/word-from-orrick/","nextPath":"/chapter/introduction/article/about-silicon-valley-bank/","parentPath":"/chapter/introduction/","chapterId":9}},{"node":{"prevPath":"/chapter/introduction/article/word-from-orrick/","path":"/chapter/introduction/article/about-silicon-valley-bank/","nextPath":"/chapter/introduction/article/studio-lovelock-website-design/","parentPath":"/chapter/introduction/","chapterId":9}},{"node":{"prevPath":"/chapter/introduction/article/about-silicon-valley-bank/","path":"/chapter/introduction/article/studio-lovelock-website-design/","nextPath":"/chapter/evolving-europe/","parentPath":"/chapter/introduction/","chapterId":9}},{"node":{"prevPath":"/chapter/evolving-europe/","path":"/chapter/evolving-europe/article/its-been-busy-year-european-tech/","nextPath":"/chapter/evolving-europe/article/europe-remains-bullish-about-future/","parentPath":"/chapter/evolving-europe/","chapterId":10}},{"node":{"prevPath":"/chapter/evolving-europe/article/its-been-busy-year-european-tech/","path":"/chapter/evolving-europe/article/europe-remains-bullish-about-future/","nextPath":"/chapter/evolving-europe/article/macro-events-europes-tech-ecosystem/","parentPath":"/chapter/evolving-europe/","chapterId":10}},{"node":{"prevPath":"/chapter/evolving-europe/article/europe-remains-bullish-about-future/","path":"/chapter/evolving-europe/article/macro-events-europes-tech-ecosystem/","nextPath":"/chapter/evolving-europe/article/european-entrepreneurs-worlds-biggest-problems/","parentPath":"/chapter/evolving-europe/","chapterId":10}},{"node":{"prevPath":"/chapter/evolving-europe/article/macro-events-europes-tech-ecosystem/","path":"/chapter/evolving-europe/article/european-entrepreneurs-worlds-biggest-problems/","nextPath":"/chapter/evolving-europe/article/european-tech-continues-diversify-geographically/","parentPath":"/chapter/evolving-europe/","chapterId":10}},{"node":{"prevPath":"/chapter/evolving-europe/article/european-entrepreneurs-worlds-biggest-problems/","path":"/chapter/evolving-europe/article/european-tech-continues-diversify-geographically/","nextPath":"/chapter/evolving-europe/article/gender-diversity-problem-/","parentPath":"/chapter/evolving-europe/","chapterId":10}},{"node":{"prevPath":"/chapter/evolving-europe/article/european-tech-continues-diversify-geographically/","path":"/chapter/evolving-europe/article/gender-diversity-problem-/","nextPath":"/chapter/talent/","parentPath":"/chapter/evolving-europe/","chapterId":10}},{"node":{"prevPath":"/chapter/talent/","path":"/chapter/talent/article/strong-pipeline-world-class-talent/","nextPath":"/chapter/talent/article/europes-tech-workforce-and-dev-population-booming/","parentPath":"/chapter/talent/","chapterId":11}},{"node":{"prevPath":"/chapter/talent/article/strong-pipeline-world-class-talent/","path":"/chapter/talent/article/europes-tech-workforce-and-dev-population-booming/","nextPath":"/chapter/talent/article/big-tech-giants-are-growing-presence/","parentPath":"/chapter/talent/","chapterId":11}},{"node":{"prevPath":"/chapter/talent/article/europes-tech-workforce-and-dev-population-booming/","path":"/chapter/talent/article/big-tech-giants-are-growing-presence/","nextPath":"/chapter/talent/article/tech-talent-movement-in-europe/","parentPath":"/chapter/talent/","chapterId":11}},{"node":{"prevPath":"/chapter/talent/article/big-tech-giants-are-growing-presence/","path":"/chapter/talent/article/tech-talent-movement-in-europe/","nextPath":"/chapter/talent/article/uk-larger-share-outbound-tech-talent-migration/","parentPath":"/chapter/talent/","chapterId":11}},{"node":{"prevPath":"/chapter/talent/article/tech-talent-movement-in-europe/","path":"/chapter/talent/article/uk-larger-share-outbound-tech-talent-migration/","nextPath":"/chapter/talent/article/portrait-european-founder/","parentPath":"/chapter/talent/","chapterId":11}},{"node":{"prevPath":"/chapter/talent/article/uk-larger-share-outbound-tech-talent-migration/","path":"/chapter/talent/article/portrait-european-founder/","nextPath":"/chapter/community/","parentPath":"/chapter/talent/","chapterId":11}},{"node":{"prevPath":"/chapter/community/","path":"/chapter/community/article/growing-and-highly-engaged-tech-communities/","nextPath":"/chapter/community/article/every-european-city-becoming-tech-hub/","parentPath":"/chapter/community/","chapterId":12}},{"node":{"prevPath":"/chapter/community/article/growing-and-highly-engaged-tech-communities/","path":"/chapter/community/article/every-european-city-becoming-tech-hub/","nextPath":"/chapter/community/article/capital-founder-mobility-links-europes-hubs/","parentPath":"/chapter/community/","chapterId":12}},{"node":{"prevPath":"/chapter/community/article/every-european-city-becoming-tech-hub/","path":"/chapter/community/article/capital-founder-mobility-links-europes-hubs/","nextPath":"/chapter/capital-flows/","parentPath":"/chapter/community/","chapterId":12}},{"node":{"prevPath":"/chapter/capital-flows/","path":"/chapter/capital-flows/article/another-record-year-european-tech-investment/","nextPath":"/chapter/capital-flows/article/deep-dive-european-tech/","parentPath":"/chapter/capital-flows/","chapterId":13}},{"node":{"prevPath":"/chapter/capital-flows/article/another-record-year-european-tech-investment/","path":"/chapter/capital-flows/article/deep-dive-european-tech/","nextPath":"/chapter/capital-flows/article/strength-europes-tech-ecosystem-investors/","parentPath":"/chapter/capital-flows/","chapterId":13}},{"node":{"prevPath":"/chapter/capital-flows/article/deep-dive-european-tech/","path":"/chapter/capital-flows/article/strength-europes-tech-ecosystem-investors/","nextPath":"/chapter/capital-flows/article/european-vcs-deliver-strong-year-fundraising/","parentPath":"/chapter/capital-flows/","chapterId":13}},{"node":{"prevPath":"/chapter/capital-flows/article/strength-europes-tech-ecosystem-investors/","path":"/chapter/capital-flows/article/european-vcs-deliver-strong-year-fundraising/","nextPath":"/chapter/capital-flows/article/attract-more-institutional-investors/","parentPath":"/chapter/capital-flows/","chapterId":13}},{"node":{"prevPath":"/chapter/capital-flows/article/european-vcs-deliver-strong-year-fundraising/","path":"/chapter/capital-flows/article/attract-more-institutional-investors/","nextPath":"/chapter/deep-tech/","parentPath":"/chapter/capital-flows/","chapterId":13}},{"node":{"prevPath":"/chapter/deep-tech/","path":"/chapter/deep-tech/article/european-deep-tech-seize-global-opportunities/","nextPath":"/chapter/deep-tech/article/ai-crypto-major-opportunity-europe/","parentPath":"/chapter/deep-tech/","chapterId":14}},{"node":{"prevPath":"/chapter/deep-tech/article/european-deep-tech-seize-global-opportunities/","path":"/chapter/deep-tech/article/ai-crypto-major-opportunity-europe/","nextPath":"/chapter/deep-tech/article/europes-engineering-engaging-data-science/","parentPath":"/chapter/deep-tech/","chapterId":14}},{"node":{"prevPath":"/chapter/deep-tech/article/ai-crypto-major-opportunity-europe/","path":"/chapter/deep-tech/article/europes-engineering-engaging-data-science/","nextPath":"/chapter/deep-tech/article/europe-key-role-crypto-space/","parentPath":"/chapter/deep-tech/","chapterId":14}},{"node":{"prevPath":"/chapter/deep-tech/article/europes-engineering-engaging-data-science/","path":"/chapter/deep-tech/article/europe-key-role-crypto-space/","nextPath":"/chapter/deep-tech/article/europe-front-and-centre-race-in-ico-boom/","parentPath":"/chapter/deep-tech/","chapterId":14}},{"node":{"prevPath":"/chapter/deep-tech/article/europe-key-role-crypto-space/","path":"/chapter/deep-tech/article/europe-front-and-centre-race-in-ico-boom/","nextPath":"/chapter/corporate/","parentPath":"/chapter/deep-tech/","chapterId":14}},{"node":{"prevPath":"/chapter/corporate/","path":"/chapter/corporate/article/european-tech-forge-ties-traditional-industry/","nextPath":"/chapter/corporate/article/europes-corporates-battling-defend-trillions-value/","parentPath":"/chapter/corporate/","chapterId":15}},{"node":{"prevPath":"/chapter/corporate/article/european-tech-forge-ties-traditional-industry/","path":"/chapter/corporate/article/europes-corporates-battling-defend-trillions-value/","nextPath":"/chapter/corporate/article/patterns-flow-talent-tech-traditional-industry/","parentPath":"/chapter/corporate/","chapterId":15}},{"node":{"prevPath":"/chapter/corporate/article/europes-corporates-battling-defend-trillions-value/","path":"/chapter/corporate/article/patterns-flow-talent-tech-traditional-industry/","nextPath":"/chapter/corporate/article/europes-traditional-incumbents-hungry/","parentPath":"/chapter/corporate/","chapterId":15}},{"node":{"prevPath":"/chapter/corporate/article/patterns-flow-talent-tech-traditional-industry/","path":"/chapter/corporate/article/europes-traditional-incumbents-hungry/","nextPath":"/chapter/regulation/","parentPath":"/chapter/corporate/","chapterId":15}},{"node":{"prevPath":"/chapter/regulation/","path":"/chapter/regulation/article/regulation-viewed-barrier-scaling-european-tech/","nextPath":"/chapter/regulation/article/regulation-to-become-strategic-advantage/","parentPath":"/chapter/regulation/","chapterId":16}},{"node":{"prevPath":"/chapter/regulation/article/regulation-viewed-barrier-scaling-european-tech/","path":"/chapter/regulation/article/regulation-to-become-strategic-advantage/","nextPath":"/chapter/success-stories-exits/","parentPath":"/chapter/regulation/","chapterId":16}},{"node":{"prevPath":"/chapter/success-stories-exits/","path":"/chapter/success-stories-exits/article/europes-billion-dollar-success-stories/","nextPath":"/chapter/success-stories-exits/article/europe-track-another-75-exit-value-2017/","parentPath":"/chapter/success-stories-exits/","chapterId":17}},{"node":{"prevPath":"/chapter/success-stories-exits/article/europes-billion-dollar-success-stories/","path":"/chapter/success-stories-exits/article/europe-track-another-75-exit-value-2017/","nextPath":"/chapter/success-stories-exits/article/european-tech-another-strong-year-ipos/","parentPath":"/chapter/success-stories-exits/","chapterId":17}},{"node":{"prevPath":"/chapter/success-stories-exits/article/europe-track-another-75-exit-value-2017/","path":"/chapter/success-stories-exits/article/european-tech-another-strong-year-ipos/","nextPath":"/chapter/mythbusting/","parentPath":"/chapter/success-stories-exits/","chapterId":17}},{"node":{"prevPath":"/chapter/mythbusting/","path":"/chapter/mythbusting/article/european-venture-delivers-returns/","nextPath":"/chapter/mythbusting/article/european-investors-localised/","parentPath":"/chapter/mythbusting/","chapterId":18}},{"node":{"prevPath":"/chapter/mythbusting/article/european-venture-delivers-returns/","path":"/chapter/mythbusting/article/european-investors-localised/","nextPath":"/chapter/mythbusting/article/european-public-market-investors-get-tech/","parentPath":"/chapter/mythbusting/","chapterId":18}},{"node":{"prevPath":"/chapter/mythbusting/article/european-investors-localised/","path":"/chapter/mythbusting/article/european-public-market-investors-get-tech/","nextPath":"/chapter/whats-next/","parentPath":"/chapter/mythbusting/","chapterId":18}},{"node":{"prevPath":"/chapter/whats-next/","path":"/chapter/whats-next/article/predictions-european-tech-2018/","nextPath":"/chapter/appendix/","parentPath":"/chapter/whats-next/","chapterId":19}},{"node":{"prevPath":"/chapter/appendix/","path":"/chapter/appendix/article/survey-respondents/","nextPath":"/chapter/appendix/article/more-about-our-data-partners/","parentPath":"/chapter/appendix/","chapterId":20}},{"node":{"prevPath":"/chapter/appendix/article/survey-respondents/","path":"/chapter/appendix/article/more-about-our-data-partners/","nextPath":"/chapter/acknowledgements/","parentPath":"/chapter/appendix/","chapterId":20}},{"node":{"prevPath":"/chapter/acknowledgements/","path":"/chapter/acknowledgements/article/contributors/","nextPath":"","parentPath":"/chapter/acknowledgements/","chapterId":21}}]}},"layoutContext":{}}

/***/ }),

/***/ 445:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _index = __webpack_require__(489);
	
	var _index2 = _interopRequireDefault(_index);
	
	var _layoutIndex = __webpack_require__(320);
	
	var _layoutIndex2 = _interopRequireDefault(_layoutIndex);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function (props) {
	  return _react2.default.createElement(_index2.default, _extends({}, props, _layoutIndex2.default));
	};
	
	module.exports = exports["default"];

/***/ }),

/***/ 584:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = addClass;
	
	var _hasClass = __webpack_require__(585);
	
	var _hasClass2 = _interopRequireDefault(_hasClass);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function addClass(element, className) {
	  if (element.classList) element.classList.add(className);else if (!(0, _hasClass2.default)(element)) element.className = element.className + ' ' + className;
	}
	module.exports = exports['default'];

/***/ }),

/***/ 585:
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = hasClass;
	function hasClass(element, className) {
	  if (element.classList) return !!className && element.classList.contains(className);else return (" " + element.className + " ").indexOf(" " + className + " ") !== -1;
	}
	module.exports = exports["default"];

/***/ }),

/***/ 586:
/***/ (function(module, exports) {

	'use strict';
	
	module.exports = function removeClass(element, className) {
	  if (element.classList) element.classList.remove(className);else element.className = element.className.replace(new RegExp('(^|\\s)' + className + '(?:\\s|$)', 'g'), '$1').replace(/\s+/g, ' ').replace(/^\s*|\s*$/g, '');
	};

/***/ }),

/***/ 896:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.bodyOpenClassName = exports.portalClassName = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactDom = __webpack_require__(99);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _ModalPortal = __webpack_require__(897);
	
	var _ModalPortal2 = _interopRequireDefault(_ModalPortal);
	
	var _ariaAppHider = __webpack_require__(401);
	
	var ariaAppHider = _interopRequireWildcard(_ariaAppHider);
	
	var _safeHTMLElement = __webpack_require__(403);
	
	var _safeHTMLElement2 = _interopRequireDefault(_safeHTMLElement);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var portalClassName = exports.portalClassName = "ReactModalPortal";
	var bodyOpenClassName = exports.bodyOpenClassName = "ReactModal__Body--open";
	
	var isReact16 = _reactDom2.default.createPortal !== undefined;
	var createPortal = isReact16 ? _reactDom2.default.createPortal : _reactDom2.default.unstable_renderSubtreeIntoContainer;
	
	function getParentElement(parentSelector) {
	  return parentSelector();
	}
	
	var Modal = function (_Component) {
	  _inherits(Modal, _Component);
	
	  function Modal() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, Modal);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = Modal.__proto__ || Object.getPrototypeOf(Modal)).call.apply(_ref, [this].concat(args))), _this), _this.removePortal = function () {
	      !isReact16 && _reactDom2.default.unmountComponentAtNode(_this.node);
	      var parent = getParentElement(_this.props.parentSelector);
	      parent.removeChild(_this.node);
	    }, _this.portalRef = function (ref) {
	      _this.portal = ref;
	    }, _this.renderPortal = function (props) {
	      var portal = createPortal(_this, _react2.default.createElement(_ModalPortal2.default, _extends({ defaultStyles: Modal.defaultStyles }, props)), _this.node);
	      _this.portalRef(portal);
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  _createClass(Modal, [{
	    key: "componentDidMount",
	    value: function componentDidMount() {
	      if (!_safeHTMLElement.canUseDOM) return;
	
	      if (!isReact16) {
	        this.node = document.createElement("div");
	      }
	      this.node.className = this.props.portalClassName;
	
	      var parent = getParentElement(this.props.parentSelector);
	      parent.appendChild(this.node);
	
	      !isReact16 && this.renderPortal(this.props);
	    }
	  }, {
	    key: "componentWillReceiveProps",
	    value: function componentWillReceiveProps(newProps) {
	      if (!_safeHTMLElement.canUseDOM) return;
	      var isOpen = newProps.isOpen;
	      // Stop unnecessary renders if modal is remaining closed
	
	      if (!this.props.isOpen && !isOpen) return;
	
	      var currentParent = getParentElement(this.props.parentSelector);
	      var newParent = getParentElement(newProps.parentSelector);
	
	      if (newParent !== currentParent) {
	        currentParent.removeChild(this.node);
	        newParent.appendChild(this.node);
	      }
	
	      !isReact16 && this.renderPortal(newProps);
	    }
	  }, {
	    key: "componentWillUpdate",
	    value: function componentWillUpdate(newProps) {
	      if (!_safeHTMLElement.canUseDOM) return;
	      if (newProps.portalClassName !== this.props.portalClassName) {
	        this.node.className = newProps.portalClassName;
	      }
	    }
	  }, {
	    key: "componentWillUnmount",
	    value: function componentWillUnmount() {
	      if (!_safeHTMLElement.canUseDOM || !this.node || !this.portal) return;
	
	      var state = this.portal.state;
	      var now = Date.now();
	      var closesAt = state.isOpen && this.props.closeTimeoutMS && (state.closesAt || now + this.props.closeTimeoutMS);
	
	      if (closesAt) {
	        if (!state.beforeClose) {
	          this.portal.closeWithTimeout();
	        }
	
	        setTimeout(this.removePortal, closesAt - now);
	      } else {
	        this.removePortal();
	      }
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      if (!_safeHTMLElement.canUseDOM || !isReact16) {
	        return null;
	      }
	
	      if (!this.node && isReact16) {
	        this.node = document.createElement("div");
	      }
	
	      return createPortal(_react2.default.createElement(_ModalPortal2.default, _extends({
	        ref: this.portalRef,
	        defaultStyles: Modal.defaultStyles
	      }, this.props)), this.node);
	    }
	  }], [{
	    key: "setAppElement",
	    value: function setAppElement(element) {
	      ariaAppHider.setElement(element);
	    }
	
	    /* eslint-disable react/no-unused-prop-types */
	
	    /* eslint-enable react/no-unused-prop-types */
	
	  }]);
	
	  return Modal;
	}(_react.Component);
	
	Modal.propTypes = {
	  isOpen: _propTypes2.default.bool.isRequired,
	  style: _propTypes2.default.shape({
	    content: _propTypes2.default.object,
	    overlay: _propTypes2.default.object
	  }),
	  portalClassName: _propTypes2.default.string,
	  bodyOpenClassName: _propTypes2.default.string,
	  className: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.shape({
	    base: _propTypes2.default.string.isRequired,
	    afterOpen: _propTypes2.default.string.isRequired,
	    beforeClose: _propTypes2.default.string.isRequired
	  })]),
	  overlayClassName: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.shape({
	    base: _propTypes2.default.string.isRequired,
	    afterOpen: _propTypes2.default.string.isRequired,
	    beforeClose: _propTypes2.default.string.isRequired
	  })]),
	  appElement: _propTypes2.default.instanceOf(_safeHTMLElement2.default),
	  onAfterOpen: _propTypes2.default.func,
	  onRequestClose: _propTypes2.default.func,
	  closeTimeoutMS: _propTypes2.default.number,
	  ariaHideApp: _propTypes2.default.bool,
	  shouldFocusAfterRender: _propTypes2.default.bool,
	  shouldCloseOnOverlayClick: _propTypes2.default.bool,
	  shouldReturnFocusAfterClose: _propTypes2.default.bool,
	  parentSelector: _propTypes2.default.func,
	  aria: _propTypes2.default.object,
	  role: _propTypes2.default.string,
	  contentLabel: _propTypes2.default.string,
	  shouldCloseOnEsc: _propTypes2.default.bool
	};
	Modal.defaultProps = {
	  isOpen: false,
	  portalClassName: portalClassName,
	  bodyOpenClassName: bodyOpenClassName,
	  ariaHideApp: true,
	  closeTimeoutMS: 0,
	  shouldFocusAfterRender: true,
	  shouldCloseOnEsc: true,
	  shouldCloseOnOverlayClick: true,
	  shouldReturnFocusAfterClose: true,
	  parentSelector: function parentSelector() {
	    return document.body;
	  }
	};
	Modal.defaultStyles = {
	  overlay: {
	    position: "fixed",
	    top: 0,
	    left: 0,
	    right: 0,
	    bottom: 0,
	    backgroundColor: "rgba(255, 255, 255, 0.75)"
	  },
	  content: {
	    position: "absolute",
	    top: "40px",
	    left: "40px",
	    right: "40px",
	    bottom: "40px",
	    border: "1px solid #ccc",
	    background: "#fff",
	    overflow: "auto",
	    WebkitOverflowScrolling: "touch",
	    borderRadius: "4px",
	    outline: "none",
	    padding: "20px"
	  }
	};
	exports.default = Modal;

/***/ }),

/***/ 897:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _focusManager = __webpack_require__(899);
	
	var focusManager = _interopRequireWildcard(_focusManager);
	
	var _scopeTab = __webpack_require__(900);
	
	var _scopeTab2 = _interopRequireDefault(_scopeTab);
	
	var _ariaAppHider = __webpack_require__(401);
	
	var ariaAppHider = _interopRequireWildcard(_ariaAppHider);
	
	var _refCount = __webpack_require__(402);
	
	var refCount = _interopRequireWildcard(_refCount);
	
	var _bodyClassList = __webpack_require__(898);
	
	var bodyClassList = _interopRequireWildcard(_bodyClassList);
	
	var _safeHTMLElement = __webpack_require__(403);
	
	var _safeHTMLElement2 = _interopRequireDefault(_safeHTMLElement);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	// so that our CSS is statically analyzable
	var CLASS_NAMES = {
	  overlay: "ReactModal__Overlay",
	  content: "ReactModal__Content"
	};
	
	var TAB_KEY = 9;
	var ESC_KEY = 27;
	
	var ModalPortal = function (_Component) {
	  _inherits(ModalPortal, _Component);
	
	  function ModalPortal(props) {
	    _classCallCheck(this, ModalPortal);
	
	    var _this = _possibleConstructorReturn(this, (ModalPortal.__proto__ || Object.getPrototypeOf(ModalPortal)).call(this, props));
	
	    _this.setFocusAfterRender = function (focus) {
	      _this.focusAfterRender = _this.props.shouldFocusAfterRender && focus;
	    };
	
	    _this.setOverlayRef = function (overlay) {
	      _this.overlay = overlay;
	    };
	
	    _this.setContentRef = function (content) {
	      _this.content = content;
	    };
	
	    _this.afterClose = function () {
	      // Remove body class
	      bodyClassList.remove(_this.props.bodyOpenClassName);
	
	      if (_this.props.shouldFocusAfterRender) {
	        if (_this.props.shouldReturnFocusAfterClose) {
	          focusManager.returnFocus();
	          focusManager.teardownScopedFocus();
	        } else {
	          focusManager.popWithoutFocus();
	        }
	      }
	    };
	
	    _this.open = function () {
	      _this.beforeOpen();
	      if (_this.state.afterOpen && _this.state.beforeClose) {
	        clearTimeout(_this.closeTimer);
	        _this.setState({ beforeClose: false });
	      } else {
	        if (_this.props.shouldFocusAfterRender) {
	          focusManager.setupScopedFocus(_this.node);
	          focusManager.markForFocusLater();
	        }
	
	        _this.setState({ isOpen: true }, function () {
	          _this.setState({ afterOpen: true });
	
	          if (_this.props.isOpen && _this.props.onAfterOpen) {
	            _this.props.onAfterOpen();
	          }
	        });
	      }
	    };
	
	    _this.close = function () {
	      _this.beforeClose();
	      if (_this.props.closeTimeoutMS > 0) {
	        _this.closeWithTimeout();
	      } else {
	        _this.closeWithoutTimeout();
	      }
	    };
	
	    _this.focusContent = function () {
	      return _this.content && !_this.contentHasFocus() && _this.content.focus();
	    };
	
	    _this.closeWithTimeout = function () {
	      var closesAt = Date.now() + _this.props.closeTimeoutMS;
	      _this.setState({ beforeClose: true, closesAt: closesAt }, function () {
	        _this.closeTimer = setTimeout(_this.closeWithoutTimeout, _this.state.closesAt - Date.now());
	      });
	    };
	
	    _this.closeWithoutTimeout = function () {
	      _this.setState({
	        beforeClose: false,
	        isOpen: false,
	        afterOpen: false,
	        closesAt: null
	      }, _this.afterClose);
	    };
	
	    _this.handleKeyDown = function (event) {
	      if (event.keyCode === TAB_KEY) {
	        (0, _scopeTab2.default)(_this.content, event);
	      }
	
	      if (_this.props.shouldCloseOnEsc && event.keyCode === ESC_KEY) {
	        event.preventDefault();
	        _this.requestClose(event);
	      }
	    };
	
	    _this.handleOverlayOnClick = function (event) {
	      if (_this.shouldClose === null) {
	        _this.shouldClose = true;
	      }
	
	      if (_this.shouldClose && _this.props.shouldCloseOnOverlayClick) {
	        if (_this.ownerHandlesClose()) {
	          _this.requestClose(event);
	        } else {
	          _this.focusContent();
	        }
	      }
	      _this.shouldClose = null;
	      _this.moveFromContentToOverlay = null;
	    };
	
	    _this.handleOverlayOnMouseUp = function () {
	      if (_this.moveFromContentToOverlay === null) {
	        _this.shouldClose = false;
	      }
	    };
	
	    _this.handleContentOnMouseUp = function () {
	      _this.shouldClose = false;
	    };
	
	    _this.handleOverlayOnMouseDown = function () {
	      _this.moveFromContentToOverlay = false;
	    };
	
	    _this.handleContentOnClick = function () {
	      _this.shouldClose = false;
	    };
	
	    _this.handleContentOnMouseDown = function () {
	      _this.shouldClose = false;
	      _this.moveFromContentToOverlay = false;
	    };
	
	    _this.requestClose = function (event) {
	      return _this.ownerHandlesClose() && _this.props.onRequestClose(event);
	    };
	
	    _this.ownerHandlesClose = function () {
	      return _this.props.onRequestClose;
	    };
	
	    _this.shouldBeClosed = function () {
	      return !_this.state.isOpen && !_this.state.beforeClose;
	    };
	
	    _this.contentHasFocus = function () {
	      return document.activeElement === _this.content || _this.content.contains(document.activeElement);
	    };
	
	    _this.buildClassName = function (which, additional) {
	      var classNames = (typeof additional === "undefined" ? "undefined" : _typeof(additional)) === "object" ? additional : {
	        base: CLASS_NAMES[which],
	        afterOpen: CLASS_NAMES[which] + "--after-open",
	        beforeClose: CLASS_NAMES[which] + "--before-close"
	      };
	      var className = classNames.base;
	      if (_this.state.afterOpen) {
	        className = className + " " + classNames.afterOpen;
	      }
	      if (_this.state.beforeClose) {
	        className = className + " " + classNames.beforeClose;
	      }
	      return typeof additional === "string" && additional ? className + " " + additional : className;
	    };
	
	    _this.ariaAttributes = function (items) {
	      return Object.keys(items).reduce(function (acc, name) {
	        acc["aria-" + name] = items[name];
	        return acc;
	      }, {});
	    };
	
	    _this.state = {
	      afterOpen: false,
	      beforeClose: false
	    };
	
	    _this.shouldClose = null;
	    _this.moveFromContentToOverlay = null;
	    return _this;
	  }
	
	  _createClass(ModalPortal, [{
	    key: "componentDidMount",
	    value: function componentDidMount() {
	      // Focus needs to be set when mounting and already open
	      if (this.props.isOpen) {
	        this.setFocusAfterRender(true);
	        this.open();
	      }
	    }
	  }, {
	    key: "componentWillReceiveProps",
	    value: function componentWillReceiveProps(newProps) {
	      if (false) {
	        if (newProps.bodyOpenClassName !== this.props.bodyOpenClassName) {
	          // eslint-disable-next-line no-console
	          console.warn('React-Modal: "bodyOpenClassName" prop has been modified. ' + "This may cause unexpected behavior when multiple modals are open.");
	        }
	      }
	      // Focus only needs to be set once when the modal is being opened
	      if (!this.props.isOpen && newProps.isOpen) {
	        this.setFocusAfterRender(true);
	        this.open();
	      } else if (this.props.isOpen && !newProps.isOpen) {
	        this.close();
	      }
	    }
	  }, {
	    key: "componentDidUpdate",
	    value: function componentDidUpdate() {
	      if (this.focusAfterRender) {
	        this.focusContent();
	        this.setFocusAfterRender(false);
	      }
	    }
	  }, {
	    key: "componentWillUnmount",
	    value: function componentWillUnmount() {
	      // Remove body class
	      bodyClassList.remove(this.props.bodyOpenClassName);
	      this.beforeClose();
	      clearTimeout(this.closeTimer);
	    }
	  }, {
	    key: "beforeOpen",
	    value: function beforeOpen() {
	      var _props = this.props,
	          appElement = _props.appElement,
	          ariaHideApp = _props.ariaHideApp,
	          bodyOpenClassName = _props.bodyOpenClassName;
	      // Add body class
	
	      bodyClassList.add(bodyOpenClassName);
	      // Add aria-hidden to appElement
	      if (ariaHideApp) {
	        ariaAppHider.hide(appElement);
	      }
	    }
	  }, {
	    key: "beforeClose",
	    value: function beforeClose() {
	      var _props2 = this.props,
	          appElement = _props2.appElement,
	          ariaHideApp = _props2.ariaHideApp;
	      // Reset aria-hidden attribute if all modals have been removed
	
	      if (ariaHideApp && refCount.totalCount() < 1) {
	        ariaAppHider.show(appElement);
	      }
	    }
	
	    // Don't steal focus from inner elements
	
	  }, {
	    key: "render",
	    value: function render() {
	      var _props3 = this.props,
	          className = _props3.className,
	          overlayClassName = _props3.overlayClassName,
	          defaultStyles = _props3.defaultStyles;
	
	      var contentStyles = className ? {} : defaultStyles.content;
	      var overlayStyles = overlayClassName ? {} : defaultStyles.overlay;
	
	      return this.shouldBeClosed() ? null : _react2.default.createElement(
	        "div",
	        {
	          ref: this.setOverlayRef,
	          className: this.buildClassName("overlay", overlayClassName),
	          style: _extends({}, overlayStyles, this.props.style.overlay),
	          onClick: this.handleOverlayOnClick,
	          onMouseDown: this.handleOverlayOnMouseDown,
	          onMouseUp: this.handleOverlayOnMouseUp
	        },
	        _react2.default.createElement(
	          "div",
	          _extends({
	            ref: this.setContentRef,
	            style: _extends({}, contentStyles, this.props.style.content),
	            className: this.buildClassName("content", className),
	            tabIndex: "-1",
	            onKeyDown: this.handleKeyDown,
	            onMouseDown: this.handleContentOnMouseDown,
	            onMouseUp: this.handleContentOnMouseUp,
	            onClick: this.handleContentOnClick,
	            role: this.props.role,
	            "aria-label": this.props.contentLabel
	          }, this.ariaAttributes(this.props.aria || {})),
	          this.props.children
	        )
	      );
	    }
	  }]);
	
	  return ModalPortal;
	}(_react.Component);
	
	ModalPortal.defaultProps = {
	  style: {
	    overlay: {},
	    content: {}
	  }
	};
	ModalPortal.propTypes = {
	  isOpen: _propTypes2.default.bool.isRequired,
	  defaultStyles: _propTypes2.default.shape({
	    content: _propTypes2.default.object,
	    overlay: _propTypes2.default.object
	  }),
	  style: _propTypes2.default.shape({
	    content: _propTypes2.default.object,
	    overlay: _propTypes2.default.object
	  }),
	  className: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.object]),
	  overlayClassName: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.object]),
	  bodyOpenClassName: _propTypes2.default.string,
	  ariaHideApp: _propTypes2.default.bool,
	  appElement: _propTypes2.default.instanceOf(_safeHTMLElement2.default),
	  onAfterOpen: _propTypes2.default.func,
	  onRequestClose: _propTypes2.default.func,
	  closeTimeoutMS: _propTypes2.default.number,
	  shouldFocusAfterRender: _propTypes2.default.bool,
	  shouldCloseOnOverlayClick: _propTypes2.default.bool,
	  shouldReturnFocusAfterClose: _propTypes2.default.bool,
	  role: _propTypes2.default.string,
	  contentLabel: _propTypes2.default.string,
	  aria: _propTypes2.default.object,
	  children: _propTypes2.default.node,
	  shouldCloseOnEsc: _propTypes2.default.bool
	};
	exports.default = ModalPortal;
	module.exports = exports["default"];

/***/ }),

/***/ 401:
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.assertNodeList = assertNodeList;
	exports.setElement = setElement;
	exports.tryForceFallback = tryForceFallback;
	exports.validateElement = validateElement;
	exports.hide = hide;
	exports.show = show;
	exports.documentNotReadyOrSSRTesting = documentNotReadyOrSSRTesting;
	exports.resetForTesting = resetForTesting;
	var globalElement = null;
	
	function assertNodeList(nodeList, selector) {
	  if (!nodeList || !nodeList.length) {
	    throw new Error("react-modal: No elements were found for selector " + selector + ".");
	  }
	}
	
	function setElement(element) {
	  var useElement = element;
	  if (typeof useElement === "string") {
	    var el = document.querySelectorAll(useElement);
	    assertNodeList(el, useElement);
	    useElement = "length" in el ? el[0] : el;
	  }
	  globalElement = useElement || globalElement;
	  return globalElement;
	}
	
	function tryForceFallback() {
	  if (document && document.body) {
	    // force fallback to document.body
	    setElement(document.body);
	    return true;
	  }
	  return false;
	}
	
	function validateElement(appElement) {
	  if (!appElement && !globalElement && !tryForceFallback()) {
	    throw new Error(["react-modal: Cannot fallback to `document.body`, because it is not", "ready or available. If you are doing server-side rendering, use this", "function to defined an element. `Modal.setAppElement(el)` to make", "this accessible"].join(" "));
	  }
	}
	
	function hide(appElement) {
	  validateElement(appElement);
	  (appElement || globalElement).setAttribute("aria-hidden", "true");
	}
	
	function show(appElement) {
	  validateElement(appElement);
	  (appElement || globalElement).removeAttribute("aria-hidden");
	}
	
	function documentNotReadyOrSSRTesting() {
	  globalElement = null;
	}
	
	function resetForTesting() {
	  globalElement = document.body;
	}

/***/ }),

/***/ 898:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.add = add;
	exports.remove = remove;
	
	var _refCount = __webpack_require__(402);
	
	var refCount = _interopRequireWildcard(_refCount);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function add(bodyClass) {
	  // Increment class(es) on refCount tracker and add class(es) to body
	  bodyClass.split(" ").map(refCount.add).forEach(function (className) {
	    return document.body.classList.add(className);
	  });
	}
	
	function remove(bodyClass) {
	  var classListMap = refCount.get();
	  // Decrement class(es) from the refCount tracker
	  // and remove unused class(es) from body
	  bodyClass.split(" ").map(refCount.remove).filter(function (className) {
	    return classListMap[className] === 0;
	  }).forEach(function (className) {
	    return document.body.classList.remove(className);
	  });
	}

/***/ }),

/***/ 899:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.handleBlur = handleBlur;
	exports.handleFocus = handleFocus;
	exports.markForFocusLater = markForFocusLater;
	exports.returnFocus = returnFocus;
	exports.popWithoutFocus = popWithoutFocus;
	exports.setupScopedFocus = setupScopedFocus;
	exports.teardownScopedFocus = teardownScopedFocus;
	
	var _tabbable = __webpack_require__(404);
	
	var _tabbable2 = _interopRequireDefault(_tabbable);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var focusLaterElements = [];
	var modalElement = null;
	var needToFocus = false;
	
	function handleBlur() {
	  needToFocus = true;
	}
	
	function handleFocus() {
	  if (needToFocus) {
	    needToFocus = false;
	    if (!modalElement) {
	      return;
	    }
	    // need to see how jQuery shims document.on('focusin') so we don't need the
	    // setTimeout, firefox doesn't support focusin, if it did, we could focus
	    // the element outside of a setTimeout. Side-effect of this implementation
	    // is that the document.body gets focus, and then we focus our element right
	    // after, seems fine.
	    setTimeout(function () {
	      if (modalElement.contains(document.activeElement)) {
	        return;
	      }
	      var el = (0, _tabbable2.default)(modalElement)[0] || modalElement;
	      el.focus();
	    }, 0);
	  }
	}
	
	function markForFocusLater() {
	  focusLaterElements.push(document.activeElement);
	}
	
	/* eslint-disable no-console */
	function returnFocus() {
	  var toFocus = null;
	  try {
	    toFocus = focusLaterElements.pop();
	    toFocus.focus();
	    return;
	  } catch (e) {
	    console.warn(["You tried to return focus to", toFocus, "but it is not in the DOM anymore"].join(" "));
	  }
	}
	/* eslint-enable no-console */
	
	function popWithoutFocus() {
	  focusLaterElements.length > 0 && focusLaterElements.pop();
	}
	
	function setupScopedFocus(element) {
	  modalElement = element;
	
	  if (window.addEventListener) {
	    window.addEventListener("blur", handleBlur, false);
	    document.addEventListener("focus", handleFocus, true);
	  } else {
	    window.attachEvent("onBlur", handleBlur);
	    document.attachEvent("onFocus", handleFocus);
	  }
	}
	
	function teardownScopedFocus() {
	  modalElement = null;
	
	  if (window.addEventListener) {
	    window.removeEventListener("blur", handleBlur);
	    document.removeEventListener("focus", handleFocus);
	  } else {
	    window.detachEvent("onBlur", handleBlur);
	    document.detachEvent("onFocus", handleFocus);
	  }
	}

/***/ }),

/***/ 402:
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.get = get;
	exports.add = add;
	exports.remove = remove;
	exports.totalCount = totalCount;
	var classListMap = {};
	
	function get() {
	  return classListMap;
	}
	
	function add(bodyClass) {
	  // Set variable and default if none
	  if (!classListMap[bodyClass]) {
	    classListMap[bodyClass] = 0;
	  }
	  classListMap[bodyClass] += 1;
	  return bodyClass;
	}
	
	function remove(bodyClass) {
	  if (classListMap[bodyClass]) {
	    classListMap[bodyClass] -= 1;
	  }
	  return bodyClass;
	}
	
	function totalCount() {
	  return Object.keys(classListMap).reduce(function (acc, curr) {
	    return acc + classListMap[curr];
	  }, 0);
	}

/***/ }),

/***/ 403:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.canUseDOM = undefined;
	
	var _exenv = __webpack_require__(380);
	
	var _exenv2 = _interopRequireDefault(_exenv);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var EE = _exenv2.default;
	
	var SafeHTMLElement = EE.canUseDOM ? window.HTMLElement : {};
	
	var canUseDOM = exports.canUseDOM = EE.canUseDOM;
	
	exports.default = SafeHTMLElement;

/***/ }),

/***/ 900:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = scopeTab;
	
	var _tabbable = __webpack_require__(404);
	
	var _tabbable2 = _interopRequireDefault(_tabbable);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function scopeTab(node, event) {
	  var tabbable = (0, _tabbable2.default)(node);
	
	  if (!tabbable.length) {
	    // Do nothing, since there are no elements that can receive focus.
	    event.preventDefault();
	    return;
	  }
	
	  var shiftKey = event.shiftKey;
	  var head = tabbable[0];
	  var tail = tabbable[tabbable.length - 1];
	
	  // proceed with default browser behavior
	  if (node === document.activeElement) {
	    return;
	  }
	
	  var target;
	  if (tail === document.activeElement && !shiftKey) {
	    target = head;
	  }
	
	  if (head === document.activeElement && shiftKey) {
	    target = tail;
	  }
	
	  if (target) {
	    event.preventDefault();
	    target.focus();
	    return;
	  }
	
	  // Safari radio issue.
	  //
	  // Safari does not move the focus to the radio button,
	  // so we need to force it to really walk through all elements.
	  //
	  // This is very error prune, since we are trying to guess
	  // if it is a safari browser from the first occurence between
	  // chrome or safari.
	  //
	  // The chrome user agent contains the first ocurrence
	  // as the 'chrome/version' and later the 'safari/version'.
	  var checkSafari = /(\bChrome\b|\bSafari\b)\//.exec(navigator.userAgent);
	  var isSafariDesktop = checkSafari != null && checkSafari[1] != "Chrome" && /\biPod\b|\biPad\b/g.exec(navigator.userAgent) == null;
	
	  // If we are not in safari desktop, let the browser control
	  // the focus
	  if (!isSafariDesktop) return;
	
	  var x = tabbable.indexOf(document.activeElement);
	
	  if (x > -1) {
	    x += shiftKey ? -1 : 1;
	  }
	
	  event.preventDefault();
	
	  tabbable[x].focus();
	}
	module.exports = exports["default"];

/***/ }),

/***/ 404:
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = findTabbableDescendants;
	/*!
	 * Adapted from jQuery UI core
	 *
	 * http://jqueryui.com
	 *
	 * Copyright 2014 jQuery Foundation and other contributors
	 * Released under the MIT license.
	 * http://jquery.org/license
	 *
	 * http://api.jqueryui.com/category/ui-core/
	 */
	
	var tabbableNode = /input|select|textarea|button|object/;
	
	function hidden(el) {
	  return el.offsetWidth <= 0 && el.offsetHeight <= 0 || el.style.display === "none";
	}
	
	function visible(element) {
	  var parentElement = element;
	  while (parentElement) {
	    if (parentElement === document.body) break;
	    if (hidden(parentElement)) return false;
	    parentElement = parentElement.parentNode;
	  }
	  return true;
	}
	
	function focusable(element, isTabIndexNotNaN) {
	  var nodeName = element.nodeName.toLowerCase();
	  var res = tabbableNode.test(nodeName) && !element.disabled || (nodeName === "a" ? element.href || isTabIndexNotNaN : isTabIndexNotNaN);
	  return res && visible(element);
	}
	
	function tabbable(element) {
	  var tabIndex = element.getAttribute("tabindex");
	  if (tabIndex === null) tabIndex = undefined;
	  var isTabIndexNaN = isNaN(tabIndex);
	  return (isTabIndexNaN || tabIndex >= 0) && focusable(element, !isTabIndexNaN);
	}
	
	function findTabbableDescendants(element) {
	  return [].slice.call(element.querySelectorAll("*"), 0).filter(tabbable);
	}
	module.exports = exports["default"];

/***/ }),

/***/ 901:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _Modal = __webpack_require__(896);
	
	var _Modal2 = _interopRequireDefault(_Modal);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _Modal2.default;
	module.exports = exports["default"];

/***/ }),

/***/ 941:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _propTypes = __webpack_require__(2);
	
	var PropTypes = _interopRequireWildcard(_propTypes);
	
	var _addClass = __webpack_require__(584);
	
	var _addClass2 = _interopRequireDefault(_addClass);
	
	var _removeClass = __webpack_require__(586);
	
	var _removeClass2 = _interopRequireDefault(_removeClass);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Transition = __webpack_require__(417);
	
	var _Transition2 = _interopRequireDefault(_Transition);
	
	var _PropTypes = __webpack_require__(418);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var addClass = function addClass(node, classes) {
	  return classes && classes.split(' ').forEach(function (c) {
	    return (0, _addClass2.default)(node, c);
	  });
	};
	var removeClass = function removeClass(node, classes) {
	  return classes && classes.split(' ').forEach(function (c) {
	    return (0, _removeClass2.default)(node, c);
	  });
	};
	
	var propTypes = _extends({}, _Transition2.default.propTypes, {
	
	  /**
	   * The animation classNames applied to the component as it enters or exits.
	   * A single name can be provided and it will be suffixed for each stage: e.g.
	   *
	   * `classNames="fade"` applies `fade-enter`, `fade-enter-active`,
	   * `fade-exit`, `fade-exit-active`, `fade-appear`, and `fade-appear-active`.
	   * Each individual classNames can also be specified independently like:
	   *
	   * ```js
	   * classNames={{
	   *  appear: 'my-appear',
	   *  appearActive: 'my-active-appear',
	   *  enter: 'my-enter',
	   *  enterActive: 'my-active-enter',
	   *  exit: 'my-exit',
	   *  exitActive: 'my-active-exit',
	   * }}
	   * ```
	   *
	   * @type {string | {
	   *  appear?: string,
	   *  appearActive?: string,
	   *  enter?: string,
	   *  enterActive?: string,
	   *  exit?: string,
	   *  exitActive?: string,
	   * }}
	   */
	  classNames: _PropTypes.classNamesShape,
	
	  /**
	   * A `<Transition>` callback fired immediately after the 'enter' or 'appear' class is
	   * applied.
	   *
	   * @type Function(node: HtmlElement, isAppearing: bool)
	   */
	  onEnter: PropTypes.func,
	
	  /**
	   * A `<Transition>` callback fired immediately after the 'enter-active' or
	   * 'appear-active' class is applied.
	   *
	   * @type Function(node: HtmlElement, isAppearing: bool)
	   */
	  onEntering: PropTypes.func,
	
	  /**
	   * A `<Transition>` callback fired immediately after the 'enter' or
	   * 'appear' classes are **removed** from the DOM node.
	   *
	   * @type Function(node: HtmlElement, isAppearing: bool)
	   */
	  onEntered: PropTypes.func,
	
	  /**
	   * A `<Transition>` callback fired immediately after the 'exit' class is
	   * applied.
	   *
	   * @type Function(node: HtmlElement)
	   */
	  onExit: PropTypes.func,
	
	  /**
	   * A `<Transition>` callback fired immediately after the 'exit-active' is applied.
	   *
	   * @type Function(node: HtmlElement
	   */
	  onExiting: PropTypes.func,
	
	  /**
	   * A `<Transition>` callback fired immediately after the 'exit' classes
	   * are **removed** from the DOM node.
	   *
	   * @type Function(node: HtmlElement)
	   */
	  onExited: PropTypes.func
	});
	
	/**
	 * A `Transition` component using CSS transitions and animations.
	 * It's inspired by the excellent [ng-animate](http://www.nganimate.org/) library.
	 *
	 * `CSSTransition` applies a pair of class names during the `appear`, `enter`,
	 * and `exit` stages of the transition. The first class is applied and then a
	 * second "active" class in order to activate the css animation.
	 *
	 * When the `in` prop is toggled to `true` the Component will get
	 * the `example-enter` CSS class and the `example-enter-active` CSS class
	 * added in the next tick. This is a convention based on the `classNames` prop.
	 *
	 * ```js
	 * import CSSTransition from 'react-transition-group/CSSTransition';
	 *
	 * const Fade = ({ children, ...props }) => (
	 *  <CSSTransition
	 *    {...props}
	 *    timeout={500}
	 *    classNames="fade"
	 *  >
	 *   {children}
	 *  </CSSTransition>
	 * );
	 *
	 * class FadeInAndOut extends React.Component {
	 *   constructor(...args) {
	 *     super(...args);
	 *     this.state= { show: false }
	 *
	 *     setInterval(() => {
	 *       this.setState({ show: !this.state.show })
	 *     }, 5000)
	 *   }
	 *   render() {
	 *     return (
	 *       <Fade in={this.state.show}>
	 *         <div>Hello world</div>
	 *       </Fade>
	 *     )
	 *   }
	 * }
	 * ```
	 *
	 * And the coorresponding CSS for the `<Fade>` component:
	 *
	 * ```css
	 * .fade-enter {
	 *   opacity: 0.01;
	 * }
	 *
	 * .fade-enter.fade-enter-active {
	 *   opacity: 1;
	 *   transition: opacity 500ms ease-in;
	 * }
	 *
	 * .fade-exit {
	 *   opacity: 1;
	 * }
	 *
	 * .fade-exit.fade-exit-active {
	 *   opacity: 0.01;
	 *   transition: opacity 300ms ease-in;
	 * }
	 * ```
	 */
	
	var CSSTransition = function (_React$Component) {
	  _inherits(CSSTransition, _React$Component);
	
	  function CSSTransition() {
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, CSSTransition);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.onEnter = function (node, appearing) {
	      var _this$getClassNames = _this.getClassNames(appearing ? 'appear' : 'enter'),
	          className = _this$getClassNames.className;
	
	      _this.removeClasses(node, 'exit');
	      addClass(node, className);
	
	      if (_this.props.onEnter) {
	        _this.props.onEnter(node);
	      }
	    }, _this.onEntering = function (node, appearing) {
	      var _this$getClassNames2 = _this.getClassNames(appearing ? 'appear' : 'enter'),
	          activeClassName = _this$getClassNames2.activeClassName;
	
	      _this.reflowAndAddClass(node, activeClassName);
	
	      if (_this.props.onEntering) {
	        _this.props.onEntering(node);
	      }
	    }, _this.onEntered = function (node, appearing) {
	      _this.removeClasses(node, appearing ? 'appear' : 'enter');
	
	      if (_this.props.onEntered) {
	        _this.props.onEntered(node);
	      }
	    }, _this.onExit = function (node) {
	      var _this$getClassNames3 = _this.getClassNames('exit'),
	          className = _this$getClassNames3.className;
	
	      _this.removeClasses(node, 'appear');
	      _this.removeClasses(node, 'enter');
	      addClass(node, className);
	
	      if (_this.props.onExit) {
	        _this.props.onExit(node);
	      }
	    }, _this.onExiting = function (node) {
	      var _this$getClassNames4 = _this.getClassNames('exit'),
	          activeClassName = _this$getClassNames4.activeClassName;
	
	      _this.reflowAndAddClass(node, activeClassName);
	
	      if (_this.props.onExiting) {
	        _this.props.onExiting(node);
	      }
	    }, _this.onExited = function (node) {
	      _this.removeClasses(node, 'exit');
	
	      if (_this.props.onExited) {
	        _this.props.onExited(node);
	      }
	    }, _this.getClassNames = function (type) {
	      var classNames = _this.props.classNames;
	
	
	      var className = typeof classNames !== 'string' ? classNames[type] : classNames + '-' + type;
	
	      var activeClassName = typeof classNames !== 'string' ? classNames[type + 'Active'] : className + '-active';
	
	      return { className: className, activeClassName: activeClassName };
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  CSSTransition.prototype.removeClasses = function removeClasses(node, type) {
	    var _getClassNames = this.getClassNames(type),
	        className = _getClassNames.className,
	        activeClassName = _getClassNames.activeClassName;
	
	    className && removeClass(node, className);
	    activeClassName && removeClass(node, activeClassName);
	  };
	
	  CSSTransition.prototype.reflowAndAddClass = function reflowAndAddClass(node, className) {
	    // This is for to force a repaint,
	    // which is necessary in order to transition styles when adding a class name.
	    /* eslint-disable no-unused-expressions */
	    node.scrollTop;
	    /* eslint-enable no-unused-expressions */
	    addClass(node, className);
	  };
	
	  CSSTransition.prototype.render = function render() {
	    var props = _extends({}, this.props);
	
	    delete props.classNames;
	
	    return _react2.default.createElement(_Transition2.default, _extends({}, props, {
	      onEnter: this.onEnter,
	      onEntered: this.onEntered,
	      onEntering: this.onEntering,
	      onExit: this.onExit,
	      onExiting: this.onExiting,
	      onExited: this.onExited
	    }));
	  };
	
	  return CSSTransition;
	}(_react2.default.Component);
	
	CSSTransition.propTypes =  false ? propTypes : {};
	
	exports.default = CSSTransition;
	module.exports = exports['default'];

/***/ }),

/***/ 417:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.EXITING = exports.ENTERED = exports.ENTERING = exports.EXITED = exports.UNMOUNTED = undefined;
	
	var _propTypes = __webpack_require__(2);
	
	var PropTypes = _interopRequireWildcard(_propTypes);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactDom = __webpack_require__(99);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	var _PropTypes = __webpack_require__(418);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var UNMOUNTED = exports.UNMOUNTED = 'unmounted';
	var EXITED = exports.EXITED = 'exited';
	var ENTERING = exports.ENTERING = 'entering';
	var ENTERED = exports.ENTERED = 'entered';
	var EXITING = exports.EXITING = 'exiting';
	
	/**
	 * The Transition component lets you describe a transition from one component
	 * state to another _over time_ with a simple declarative API. Most commonly
	 * it's used to animate the mounting and unmounting of a component, but can also
	 * be used to describe in-place transition states as well.
	 *
	 * By default the `Transition` component does not alter the behavior of the
	 * component it renders, it only tracks "enter" and "exit" states for the components.
	 * It's up to you to give meaning and effect to those states. For example we can
	 * add styles to a component when it enters or exits:
	 *
	 * ```jsx
	 * import Transition from 'react-transition-group/Transition';
	 *
	 * const duration = 300;
	 *
	 * const defaultStyle = {
	 *   transition: `opacity ${duration}ms ease-in-out`,
	 *   opacity: 0,
	 * }
	 *
	 * const transitionStyles = {
	 *   entering: { opacity: 0 },
	 *   entered:  { opacity: 1 },
	 * };
	 *
	 * const Fade = ({ in: inProp }) => (
	 *   <Transition in={inProp} timeout={duration}>
	 *     {(state) => (
	 *       <div style={{
	 *         ...defaultStyle,
	 *         ...transitionStyles[state]
	 *       }}>
	 *         I'm A fade Transition!
	 *       </div>
	 *     )}
	 *   </Transition>
	 * );
	 * ```
	 *
	 * As noted the `Transition` component doesn't _do_ anything by itself to its child component.
	 * What it does do is track transition states over time so you can update the
	 * component (such as by adding styles or classes) when it changes states.
	 *
	 * There are 4 main states a Transition can be in:
	 *  - `ENTERING`
	 *  - `ENTERED`
	 *  - `EXITING`
	 *  - `EXITED`
	 *
	 * Transition state is toggled via the `in` prop. When `true` the component begins the
	 * "Enter" stage. During this stage, the component will shift from its current transition state,
	 * to `'entering'` for the duration of the transition and then to the `'entered'` stage once
	 * it's complete. Let's take the following example:
	 *
	 * ```jsx
	 * state= { in: false };
	 *
	 * toggleEnterState = () => {
	 *   this.setState({ in: true });
	 * }
	 *
	 * render() {
	 *   return (
	 *     <div>
	 *       <Transition in={this.state.in} timeout={500} />
	 *       <button onClick={this.toggleEnterState}>Click to Enter</button>
	 *     </div>
	 *   );
	 * }
	 * ```
	 *
	 * When the button is clicked the component will shift to the `'entering'` state and
	 * stay there for 500ms (the value of `timeout`) when finally switches to `'entered'`.
	 *
	 * When `in` is `false` the same thing happens except the state moves from `'exiting'` to `'exited'`.
	 */
	
	var Transition = function (_React$Component) {
	  _inherits(Transition, _React$Component);
	
	  function Transition(props, context) {
	    _classCallCheck(this, Transition);
	
	    var _this = _possibleConstructorReturn(this, _React$Component.call(this, props, context));
	
	    var parentGroup = context.transitionGroup;
	    // In the context of a TransitionGroup all enters are really appears
	    var appear = parentGroup && !parentGroup.isMounting ? props.enter : props.appear;
	
	    var initialStatus = void 0;
	    _this.nextStatus = null;
	
	    if (props.in) {
	      if (appear) {
	        initialStatus = EXITED;
	        _this.nextStatus = ENTERING;
	      } else {
	        initialStatus = ENTERED;
	      }
	    } else {
	      if (props.unmountOnExit || props.mountOnEnter) {
	        initialStatus = UNMOUNTED;
	      } else {
	        initialStatus = EXITED;
	      }
	    }
	
	    _this.state = { status: initialStatus };
	
	    _this.nextCallback = null;
	    return _this;
	  }
	
	  Transition.prototype.getChildContext = function getChildContext() {
	    return { transitionGroup: null }; // allows for nested Transitions
	  };
	
	  Transition.prototype.componentDidMount = function componentDidMount() {
	    this.updateStatus(true);
	  };
	
	  Transition.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
	    var _ref = this.pendingState || this.state,
	        status = _ref.status;
	
	    if (nextProps.in) {
	      if (status === UNMOUNTED) {
	        this.setState({ status: EXITED });
	      }
	      if (status !== ENTERING && status !== ENTERED) {
	        this.nextStatus = ENTERING;
	      }
	    } else {
	      if (status === ENTERING || status === ENTERED) {
	        this.nextStatus = EXITING;
	      }
	    }
	  };
	
	  Transition.prototype.componentDidUpdate = function componentDidUpdate() {
	    this.updateStatus();
	  };
	
	  Transition.prototype.componentWillUnmount = function componentWillUnmount() {
	    this.cancelNextCallback();
	  };
	
	  Transition.prototype.getTimeouts = function getTimeouts() {
	    var timeout = this.props.timeout;
	
	    var exit = void 0,
	        enter = void 0,
	        appear = void 0;
	
	    exit = enter = appear = timeout;
	
	    if (timeout != null && typeof timeout !== 'number') {
	      exit = timeout.exit;
	      enter = timeout.enter;
	      appear = timeout.appear;
	    }
	    return { exit: exit, enter: enter, appear: appear };
	  };
	
	  Transition.prototype.updateStatus = function updateStatus() {
	    var mounting = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
	
	    var nextStatus = this.nextStatus;
	
	    if (nextStatus !== null) {
	      this.nextStatus = null;
	      // nextStatus will always be ENTERING or EXITING.
	      this.cancelNextCallback();
	      var node = _reactDom2.default.findDOMNode(this);
	
	      if (nextStatus === ENTERING) {
	        this.performEnter(node, mounting);
	      } else {
	        this.performExit(node);
	      }
	    } else if (this.props.unmountOnExit && this.state.status === EXITED) {
	      this.setState({ status: UNMOUNTED });
	    }
	  };
	
	  Transition.prototype.performEnter = function performEnter(node, mounting) {
	    var _this2 = this;
	
	    var enter = this.props.enter;
	
	    var appearing = this.context.transitionGroup ? this.context.transitionGroup.isMounting : mounting;
	
	    var timeouts = this.getTimeouts();
	
	    // no enter animation skip right to ENTERED
	    // if we are mounting and running this it means appear _must_ be set
	    if (!mounting && !enter) {
	      this.safeSetState({ status: ENTERED }, function () {
	        _this2.props.onEntered(node);
	      });
	      return;
	    }
	
	    this.props.onEnter(node, appearing);
	
	    this.safeSetState({ status: ENTERING }, function () {
	      _this2.props.onEntering(node, appearing);
	
	      // FIXME: appear timeout?
	      _this2.onTransitionEnd(node, timeouts.enter, function () {
	        _this2.safeSetState({ status: ENTERED }, function () {
	          _this2.props.onEntered(node, appearing);
	        });
	      });
	    });
	  };
	
	  Transition.prototype.performExit = function performExit(node) {
	    var _this3 = this;
	
	    var exit = this.props.exit;
	
	    var timeouts = this.getTimeouts();
	
	    // no exit animation skip right to EXITED
	    if (!exit) {
	      this.safeSetState({ status: EXITED }, function () {
	        _this3.props.onExited(node);
	      });
	      return;
	    }
	    this.props.onExit(node);
	
	    this.safeSetState({ status: EXITING }, function () {
	      _this3.props.onExiting(node);
	
	      _this3.onTransitionEnd(node, timeouts.exit, function () {
	        _this3.safeSetState({ status: EXITED }, function () {
	          _this3.props.onExited(node);
	        });
	      });
	    });
	  };
	
	  Transition.prototype.cancelNextCallback = function cancelNextCallback() {
	    if (this.nextCallback !== null) {
	      this.nextCallback.cancel();
	      this.nextCallback = null;
	    }
	  };
	
	  Transition.prototype.safeSetState = function safeSetState(nextState, callback) {
	    var _this4 = this;
	
	    // We need to track pending updates for instances where a cWRP fires quickly
	    // after cDM and before the state flushes, which would double trigger a
	    // transition
	    this.pendingState = nextState;
	
	    // This shouldn't be necessary, but there are weird race conditions with
	    // setState callbacks and unmounting in testing, so always make sure that
	    // we can cancel any pending setState callbacks after we unmount.
	    callback = this.setNextCallback(callback);
	    this.setState(nextState, function () {
	      _this4.pendingState = null;
	      callback();
	    });
	  };
	
	  Transition.prototype.setNextCallback = function setNextCallback(callback) {
	    var _this5 = this;
	
	    var active = true;
	
	    this.nextCallback = function (event) {
	      if (active) {
	        active = false;
	        _this5.nextCallback = null;
	
	        callback(event);
	      }
	    };
	
	    this.nextCallback.cancel = function () {
	      active = false;
	    };
	
	    return this.nextCallback;
	  };
	
	  Transition.prototype.onTransitionEnd = function onTransitionEnd(node, timeout, handler) {
	    this.setNextCallback(handler);
	
	    if (node) {
	      if (this.props.addEndListener) {
	        this.props.addEndListener(node, this.nextCallback);
	      }
	      if (timeout != null) {
	        setTimeout(this.nextCallback, timeout);
	      }
	    } else {
	      setTimeout(this.nextCallback, 0);
	    }
	  };
	
	  Transition.prototype.render = function render() {
	    var status = this.state.status;
	    if (status === UNMOUNTED) {
	      return null;
	    }
	
	    var _props = this.props,
	        children = _props.children,
	        childProps = _objectWithoutProperties(_props, ['children']);
	    // filter props for Transtition
	
	
	    delete childProps.in;
	    delete childProps.mountOnEnter;
	    delete childProps.unmountOnExit;
	    delete childProps.appear;
	    delete childProps.enter;
	    delete childProps.exit;
	    delete childProps.timeout;
	    delete childProps.addEndListener;
	    delete childProps.onEnter;
	    delete childProps.onEntering;
	    delete childProps.onEntered;
	    delete childProps.onExit;
	    delete childProps.onExiting;
	    delete childProps.onExited;
	
	    if (typeof children === 'function') {
	      return children(status, childProps);
	    }
	
	    var child = _react2.default.Children.only(children);
	    return _react2.default.cloneElement(child, childProps);
	  };
	
	  return Transition;
	}(_react2.default.Component);
	
	Transition.contextTypes = {
	  transitionGroup: PropTypes.object
	};
	Transition.childContextTypes = {
	  transitionGroup: function transitionGroup() {}
	};
	
	
	Transition.propTypes =  false ? {
	  /**
	   * A `function` child can be used instead of a React element.
	   * This function is called with the current transition status
	   * ('entering', 'entered', 'exiting', 'exited', 'unmounted'), which can used
	   * to apply context specific props to a component.
	   *
	   * ```jsx
	   * <Transition timeout={150}>
	   *   {(status) => (
	   *     <MyComponent className={`fade fade-${status}`} />
	   *   )}
	   * </Transition>
	   * ```
	   */
	  children: PropTypes.oneOfType([PropTypes.func.isRequired, PropTypes.element.isRequired]).isRequired,
	
	  /**
	   * Show the component; triggers the enter or exit states
	   */
	  in: PropTypes.bool,
	
	  /**
	   * By default the child component is mounted immediately along with
	   * the parent `Transition` component. If you want to "lazy mount" the component on the
	   * first `in={true}` you can set `mountOnEnter`. After the first enter transition the component will stay
	   * mounted, even on "exited", unless you also specify `unmountOnExit`.
	   */
	  mountOnEnter: PropTypes.bool,
	
	  /**
	   * By default the child component stays mounted after it reaches the `'exited'` state.
	   * Set `unmountOnExit` if you'd prefer to unmount the component after it finishes exiting.
	   */
	  unmountOnExit: PropTypes.bool,
	
	  /**
	   * Normally a component is not transitioned if it is shown when the `<Transition>` component mounts.
	   * If you want to transition on the first mount set `appear` to `true`, and the
	   * component will transition in as soon as the `<Transition>` mounts.
	   *
	   * > Note: there are no specific "appear" states. `appear` only adds an additional `enter` transition.
	   */
	  appear: PropTypes.bool,
	
	  /**
	   * Enable or disable enter transitions.
	   */
	  enter: PropTypes.bool,
	
	  /**
	   * Enable or disable exit transitions.
	   */
	  exit: PropTypes.bool,
	
	  /**
	   * The duration of the transition, in milliseconds.
	   * Required unless `addEventListener` is provided
	   *
	   * You may specify a single timeout for all transitions like: `timeout={500}`,
	   * or individually like:
	   *
	   * ```jsx
	   * timeout={{
	   *  enter: 300,
	   *  exit: 500,
	   * }}
	   * ```
	   *
	   * @type {number | { enter?: number, exit?: number }}
	   */
	  timeout: function timeout(props) {
	    for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
	      args[_key - 1] = arguments[_key];
	    }
	
	    var pt = _PropTypes.timeoutsShape;
	    if (!props.addEndListener) pt = pt.isRequired;
	    return pt.apply(undefined, [props].concat(args));
	  },
	
	  /**
	   * Add a custom transition end trigger. Called with the transitioning
	   * DOM node and a `done` callback. Allows for more fine grained transition end
	   * logic. **Note:** Timeouts are still used as a fallback if provided.
	   *
	   * ```jsx
	   * addEndListener={(node, done) => {
	   *   // use the css transitionend event to mark the finish of a transition
	   *   node.addEventListener('transitionend', done, false);
	   * }}
	   * ```
	   */
	  addEndListener: PropTypes.func,
	
	  /**
	   * Callback fired before the "entering" status is applied. An extra parameter
	   * `isAppearing` is supplied to indicate if the enter stage is occurring on the initial mount
	   *
	   * @type Function(node: HtmlElement, isAppearing: bool) -> void
	   */
	  onEnter: PropTypes.func,
	
	  /**
	   * Callback fired after the "entering" status is applied. An extra parameter
	   * `isAppearing` is supplied to indicate if the enter stage is occurring on the initial mount
	   *
	   * @type Function(node: HtmlElement, isAppearing: bool)
	   */
	  onEntering: PropTypes.func,
	
	  /**
	   * Callback fired after the "entered" status is applied. An extra parameter
	   * `isAppearing` is supplied to indicate if the enter stage is occurring on the initial mount
	   *
	   * @type Function(node: HtmlElement, isAppearing: bool) -> void
	   */
	  onEntered: PropTypes.func,
	
	  /**
	   * Callback fired before the "exiting" status is applied.
	   *
	   * @type Function(node: HtmlElement) -> void
	   */
	  onExit: PropTypes.func,
	
	  /**
	   * Callback fired after the "exiting" status is applied.
	   *
	   * @type Function(node: HtmlElement) -> void
	   */
	  onExiting: PropTypes.func,
	
	  /**
	   * Callback fired after the "exited" status is applied.
	   *
	   * @type Function(node: HtmlElement) -> void
	   */
	  onExited: PropTypes.func
	} : {};
	
	// Name the function so it is clearer in the documentation
	function noop() {}
	
	Transition.defaultProps = {
	  in: false,
	  mountOnEnter: false,
	  unmountOnExit: false,
	  appear: false,
	  enter: true,
	  exit: true,
	
	  onEnter: noop,
	  onEntering: noop,
	  onEntered: noop,
	
	  onExit: noop,
	  onExiting: noop,
	  onExited: noop
	};
	
	Transition.UNMOUNTED = 0;
	Transition.EXITED = 1;
	Transition.ENTERING = 2;
	Transition.ENTERED = 3;
	Transition.EXITING = 4;
	
	exports.default = Transition;

/***/ }),

/***/ 942:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _ChildMapping = __webpack_require__(943);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var values = Object.values || function (obj) {
	  return Object.keys(obj).map(function (k) {
	    return obj[k];
	  });
	};
	
	var propTypes = {
	  /**
	   * `<TransitionGroup>` renders a `<div>` by default. You can change this
	   * behavior by providing a `component` prop.
	   */
	  component: _propTypes2.default.any,
	  /**
	   * A set of `<Transition>` components, that are toggled `in` and out as they
	   * leave. the `<TransitionGroup>` will inject specific transition props, so
	   * remember to spread them through if you are wrapping the `<Transition>` as
	   * with our `<Fade>` example.
	   */
	  children: _propTypes2.default.node,
	
	  /**
	   * A convenience prop that enables or disabled appear animations
	   * for all children. Note that specifying this will override any defaults set
	   * on individual children Transitions.
	   */
	  appear: _propTypes2.default.bool,
	  /**
	   * A convenience prop that enables or disabled enter animations
	   * for all children. Note that specifying this will override any defaults set
	   * on individual children Transitions.
	   */
	  enter: _propTypes2.default.bool,
	  /**
	    * A convenience prop that enables or disabled exit animations
	    * for all children. Note that specifying this will override any defaults set
	    * on individual children Transitions.
	    */
	  exit: _propTypes2.default.bool,
	
	  /**
	   * You may need to apply reactive updates to a child as it is exiting.
	   * This is generally done by using `cloneElement` however in the case of an exiting
	   * child the element has already been removed and not accessible to the consumer.
	   *
	   * If you do need to update a child as it leaves you can provide a `childFactory`
	   * to wrap every child, even the ones that are leaving.
	   *
	   * @type Function(child: ReactElement) -> ReactElement
	   */
	  childFactory: _propTypes2.default.func
	};
	
	var defaultProps = {
	  component: 'div',
	  childFactory: function childFactory(child) {
	    return child;
	  }
	};
	
	/**
	 * The `<TransitionGroup>` component manages a set of `<Transition>` components
	 * in a list. Like with the `<Transition>` component, `<TransitionGroup>`, is a
	 * state machine for managing the mounting and unmounting of components over
	 * time.
	 *
	 * Consider the example below using the `Fade` CSS transition from before.
	 * As items are removed or added to the TodoList the `in` prop is toggled
	 * automatically by the `<TransitionGroup>`. You can use _any_ `<Transition>`
	 * component in a `<TransitionGroup>`, not just css.
	 *
	 * ```jsx
	 * import TransitionGroup from 'react-transition-group/TransitionGroup';
	 *
	 * class TodoList extends React.Component {
	 *   constructor(props) {
	 *     super(props)
	 *     this.state = {items: ['hello', 'world', 'click', 'me']}
	 *   }
	 *   handleAdd() {
	 *     const newItems = this.state.items.concat([
	 *       prompt('Enter some text')
	 *     ]);
	 *     this.setState({ items: newItems });
	 *   }
	 *   handleRemove(i) {
	 *     let newItems = this.state.items.slice();
	 *     newItems.splice(i, 1);
	 *     this.setState({items: newItems});
	 *   }
	 *   render() {
	 *     return (
	 *       <div>
	 *         <button onClick={() => this.handleAdd()}>Add Item</button>
	 *         <TransitionGroup>
	 *           {this.state.items.map((item, i) => (
	 *             <FadeTransition key={item}>
	 *               <div>
	 *                 {item}{' '}
	 *                 <button onClick={() => this.handleRemove(i)}>
	 *                   remove
	 *                 </button>
	 *               </div>
	 *             </FadeTransition>
	 *           ))}
	 *         </TransitionGroup>
	 *       </div>
	 *     );
	 *   }
	 * }
	 * ```
	 *
	 * Note that `<TransitionGroup>`  does not define any animation behavior!
	 * Exactly _how_ a list item animates is up to the individual `<Transition>`
	 * components. This means you can mix and match animations across different
	 * list items.
	 */
	
	var TransitionGroup = function (_React$Component) {
	  _inherits(TransitionGroup, _React$Component);
	
	  function TransitionGroup(props, context) {
	    _classCallCheck(this, TransitionGroup);
	
	    // Initial children should all be entering, dependent on appear
	    var _this = _possibleConstructorReturn(this, _React$Component.call(this, props, context));
	
	    _this.handleExited = function (key, node, originalHandler) {
	      var currentChildMapping = (0, _ChildMapping.getChildMapping)(_this.props.children);
	
	      if (key in currentChildMapping) return;
	
	      if (originalHandler) originalHandler(node);
	
	      _this.setState(function (state) {
	        var children = _extends({}, state.children);
	
	        delete children[key];
	        return { children: children };
	      });
	    };
	
	    _this.state = {
	      children: (0, _ChildMapping.getChildMapping)(props.children, function (child) {
	        var onExited = function onExited(node) {
	          _this.handleExited(child.key, node, child.props.onExited);
	        };
	
	        return (0, _react.cloneElement)(child, {
	          onExited: onExited,
	          in: true,
	          appear: _this.getProp(child, 'appear'),
	          enter: _this.getProp(child, 'enter'),
	          exit: _this.getProp(child, 'exit')
	        });
	      })
	    };
	    return _this;
	  }
	
	  TransitionGroup.prototype.getChildContext = function getChildContext() {
	    return {
	      transitionGroup: { isMounting: !this.appeared }
	    };
	  };
	  // use child config unless explictly set by the Group
	
	
	  TransitionGroup.prototype.getProp = function getProp(child, prop) {
	    var props = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : this.props;
	
	    return props[prop] != null ? props[prop] : child.props[prop];
	  };
	
	  TransitionGroup.prototype.componentDidMount = function componentDidMount() {
	    this.appeared = true;
	  };
	
	  TransitionGroup.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
	    var _this2 = this;
	
	    var prevChildMapping = this.state.children;
	    var nextChildMapping = (0, _ChildMapping.getChildMapping)(nextProps.children);
	
	    var children = (0, _ChildMapping.mergeChildMappings)(prevChildMapping, nextChildMapping);
	
	    Object.keys(children).forEach(function (key) {
	      var child = children[key];
	
	      if (!(0, _react.isValidElement)(child)) return;
	
	      var onExited = function onExited(node) {
	        _this2.handleExited(child.key, node, child.props.onExited);
	      };
	
	      var hasPrev = key in prevChildMapping;
	      var hasNext = key in nextChildMapping;
	
	      var prevChild = prevChildMapping[key];
	      var isLeaving = (0, _react.isValidElement)(prevChild) && !prevChild.props.in;
	
	      // item is new (entering)
	      if (hasNext && (!hasPrev || isLeaving)) {
	        // console.log('entering', key)
	        children[key] = (0, _react.cloneElement)(child, {
	          onExited: onExited,
	          in: true,
	          exit: _this2.getProp(child, 'exit', nextProps),
	          enter: _this2.getProp(child, 'enter', nextProps)
	        });
	      }
	      // item is old (exiting)
	      else if (!hasNext && hasPrev && !isLeaving) {
	          // console.log('leaving', key)
	          children[key] = (0, _react.cloneElement)(child, { in: false });
	        }
	        // item hasn't changed transition states
	        // copy over the last transition props;
	        else if (hasNext && hasPrev && (0, _react.isValidElement)(prevChild)) {
	            // console.log('unchanged', key)
	            children[key] = (0, _react.cloneElement)(child, {
	              onExited: onExited,
	              in: prevChild.props.in,
	              exit: _this2.getProp(child, 'exit', nextProps),
	              enter: _this2.getProp(child, 'enter', nextProps)
	            });
	          }
	    });
	
	    this.setState({ children: children });
	  };
	
	  TransitionGroup.prototype.render = function render() {
	    var _props = this.props,
	        Component = _props.component,
	        childFactory = _props.childFactory,
	        props = _objectWithoutProperties(_props, ['component', 'childFactory']);
	
	    var children = this.state.children;
	
	
	    delete props.appear;
	    delete props.enter;
	    delete props.exit;
	
	    return _react2.default.createElement(
	      Component,
	      props,
	      values(children).map(childFactory)
	    );
	  };
	
	  return TransitionGroup;
	}(_react2.default.Component);
	
	TransitionGroup.childContextTypes = {
	  transitionGroup: _propTypes2.default.object.isRequired
	};
	
	
	TransitionGroup.propTypes =  false ? propTypes : {};
	TransitionGroup.defaultProps = defaultProps;
	
	exports.default = TransitionGroup;
	module.exports = exports['default'];

/***/ }),

/***/ 333:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _CSSTransition = __webpack_require__(941);
	
	var _CSSTransition2 = _interopRequireDefault(_CSSTransition);
	
	var _TransitionGroup = __webpack_require__(942);
	
	var _TransitionGroup2 = _interopRequireDefault(_TransitionGroup);
	
	var _Transition = __webpack_require__(417);
	
	var _Transition2 = _interopRequireDefault(_Transition);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	module.exports = {
	  Transition: _Transition2.default,
	  TransitionGroup: _TransitionGroup2.default,
	  CSSTransition: _CSSTransition2.default
	};

/***/ }),

/***/ 943:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.getChildMapping = getChildMapping;
	exports.mergeChildMappings = mergeChildMappings;
	
	var _react = __webpack_require__(1);
	
	/**
	 * Given `this.props.children`, return an object mapping key to child.
	 *
	 * @param {*} children `this.props.children`
	 * @return {object} Mapping of key to child
	 */
	function getChildMapping(children, mapFn) {
	  var mapper = function mapper(child) {
	    return mapFn && (0, _react.isValidElement)(child) ? mapFn(child) : child;
	  };
	
	  var result = Object.create(null);
	  if (children) _react.Children.map(children, function (c) {
	    return c;
	  }).forEach(function (child) {
	    // run the map function here instead so that the key is the computed one
	    result[child.key] = mapper(child);
	  });
	  return result;
	}
	
	/**
	 * When you're adding or removing children some may be added or removed in the
	 * same render pass. We want to show *both* since we want to simultaneously
	 * animate elements in and out. This function takes a previous set of keys
	 * and a new set of keys and merges them with its best guess of the correct
	 * ordering. In the future we may expose some of the utilities in
	 * ReactMultiChild to make this easy, but for now React itself does not
	 * directly have this concept of the union of prevChildren and nextChildren
	 * so we implement it here.
	 *
	 * @param {object} prev prev children as returned from
	 * `ReactTransitionChildMapping.getChildMapping()`.
	 * @param {object} next next children as returned from
	 * `ReactTransitionChildMapping.getChildMapping()`.
	 * @return {object} a key set that contains all keys in `prev` and all keys
	 * in `next` in a reasonable order.
	 */
	function mergeChildMappings(prev, next) {
	  prev = prev || {};
	  next = next || {};
	
	  function getValueForKey(key) {
	    return key in next ? next[key] : prev[key];
	  }
	
	  // For each key of `next`, the list of keys to insert before that key in
	  // the combined list
	  var nextKeysPending = Object.create(null);
	
	  var pendingKeys = [];
	  for (var prevKey in prev) {
	    if (prevKey in next) {
	      if (pendingKeys.length) {
	        nextKeysPending[prevKey] = pendingKeys;
	        pendingKeys = [];
	      }
	    } else {
	      pendingKeys.push(prevKey);
	    }
	  }
	
	  var i = void 0;
	  var childMapping = {};
	  for (var nextKey in next) {
	    if (nextKeysPending[nextKey]) {
	      for (i = 0; i < nextKeysPending[nextKey].length; i++) {
	        var pendingNextKey = nextKeysPending[nextKey][i];
	        childMapping[nextKeysPending[nextKey][i]] = getValueForKey(pendingNextKey);
	      }
	    }
	    childMapping[nextKey] = getValueForKey(nextKey);
	  }
	
	  // Finally, add the keys which didn't appear before any key in `next`
	  for (i = 0; i < pendingKeys.length; i++) {
	    childMapping[pendingKeys[i]] = getValueForKey(pendingKeys[i]);
	  }
	
	  return childMapping;
	}

/***/ }),

/***/ 418:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.classNamesShape = exports.timeoutsShape = undefined;
	exports.transitionTimeout = transitionTimeout;
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function transitionTimeout(transitionType) {
	  var timeoutPropName = 'transition' + transitionType + 'Timeout';
	  var enabledPropName = 'transition' + transitionType;
	
	  return function (props) {
	    // If the transition is enabled
	    if (props[enabledPropName]) {
	      // If no timeout duration is provided
	      if (props[timeoutPropName] == null) {
	        return new Error(timeoutPropName + ' wasn\'t supplied to CSSTransitionGroup: ' + 'this can cause unreliable animations and won\'t be supported in ' + 'a future version of React. See ' + 'https://fb.me/react-animation-transition-group-timeout for more ' + 'information.');
	
	        // If the duration isn't a number
	      } else if (typeof props[timeoutPropName] !== 'number') {
	        return new Error(timeoutPropName + ' must be a number (in milliseconds)');
	      }
	    }
	
	    return null;
	  };
	}
	
	var timeoutsShape = exports.timeoutsShape = _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.shape({
	  enter: _propTypes2.default.number,
	  exit: _propTypes2.default.number
	}).isRequired]);
	
	var classNamesShape = exports.classNamesShape = _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.shape({
	  enter: _propTypes2.default.string,
	  exit: _propTypes2.default.string,
	  active: _propTypes2.default.string
	}), _propTypes2.default.shape({
	  enter: _propTypes2.default.string,
	  enterActive: _propTypes2.default.string,
	  exit: _propTypes2.default.string,
	  exitActive: _propTypes2.default.string
	})]);

/***/ }),

/***/ 450:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _indexModule = __webpack_require__(594);
	
	var _indexModule2 = _interopRequireDefault(_indexModule);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Banner = function Banner() {
	  return _react2.default.createElement(
	    "div",
	    { className: _indexModule2.default.root },
	    _react2.default.createElement(
	      "span",
	      { className: _indexModule2.default.text },
	      "The State of European Tech 2018 is now live"
	    ),
	    _react2.default.createElement(
	      "a",
	      {
	        href: "https://2018.stateofeuropeantech.com",
	        className: _indexModule2.default.button,
	        target: "_blank",
	        rel: "noopener noreferrer"
	      },
	      "View 2018 report"
	    )
	  );
	};
	// import PropTypes from "prop-types";
	exports.default = Banner;
	module.exports = exports["default"];

/***/ }),

/***/ 594:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"root":"src-components-Banner----index-module---root---2bVb6","text":"src-components-Banner----index-module---text---2-Msl","button":"src-components-Banner----index-module---button---rdmfl"};

/***/ }),

/***/ 876:
/***/ (function(module, exports) {

	module.exports = "<svg xmlns=\"http://www.w3.org/2000/svg\" width=\"19\" height=\"18\" viewBox=\"0 0 19 18\"><g fill=\"none\" fill-rule=\"evenodd\"><path d=\"M18.2 0L1 17.2M1 0l17.2 17.2\"/></g></svg>"

/***/ }),

/***/ 340:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _indexModule = __webpack_require__(599);
	
	var _indexModule2 = _interopRequireDefault(_indexModule);
	
	var _reactSvgInline = __webpack_require__(9);
	
	var _reactSvgInline2 = _interopRequireDefault(_reactSvgInline);
	
	var _closeIcon = __webpack_require__(876);
	
	var _closeIcon2 = _interopRequireDefault(_closeIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var CloseButton = function CloseButton(_ref) {
	  var onClick = _ref.onClick,
	      inverted = _ref.inverted;
	  return _react2.default.createElement(
	    "button",
	    {
	      className: inverted ? _indexModule2.default.rootInverted : _indexModule2.default.root,
	      onClick: onClick
	    },
	    _react2.default.createElement(
	      "span",
	      { className: _indexModule2.default.buttonInner },
	      _react2.default.createElement(_reactSvgInline2.default, { className: _indexModule2.default.closeIcon, svg: _closeIcon2.default, cleanup: ["fill"] })
	    )
	  );
	};
	
	CloseButton.propTypes = {
	  onClick: _propTypes2.default.func,
	  inverted: _propTypes2.default.bool
	};
	
	exports.default = CloseButton;
	module.exports = exports["default"];

/***/ }),

/***/ 599:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"root":"src-components-CloseButton----index-module---root---2wPy_","rootInverted":"src-components-CloseButton----index-module---rootInverted---1gw_b src-components-CloseButton----index-module---root---2wPy_","closeIcon":"src-components-CloseButton----index-module---closeIcon---hlJ9q"};

/***/ }),

/***/ 453:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _reactRedux = __webpack_require__(6);
	
	var _CookieMessage = __webpack_require__(454);
	
	var _CookieMessage2 = _interopRequireDefault(_CookieMessage);
	
	var _cookieNotice = __webpack_require__(344);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var withRedux = (0, _reactRedux.connect)(function (state) {
	  return {
	    acceptedCookieNotice: (0, _cookieNotice.getCookieNotice)(state)
	  };
	}, function (dispatch) {
	  return {
	    dismissCookieNotice: function dismissCookieNotice() {
	      dispatch((0, _cookieNotice.setCookieNotice)());
	    }
	  };
	});
	
	exports.default = withRedux(_CookieMessage2.default);
	module.exports = exports["default"];

/***/ }),

/***/ 454:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _gatsbyLink = __webpack_require__(10);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _indexModule = __webpack_require__(600);
	
	var _indexModule2 = _interopRequireDefault(_indexModule);
	
	var _ActionButton = __webpack_require__(77);
	
	var _ActionButton2 = _interopRequireDefault(_ActionButton);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var CookieMessage = function (_Component) {
	  _inherits(CookieMessage, _Component);
	
	  function CookieMessage(props) {
	    _classCallCheck(this, CookieMessage);
	
	    var _this = _possibleConstructorReturn(this, _Component.call(this, props));
	
	    _this.state = { shouldRender: false };
	    return _this;
	  }
	
	  CookieMessage.prototype.componentDidMount = function componentDidMount() {
	    // componentDidMount is only called in a browser env. Don't render this
	    // component on the server.
	    this.setState({ shouldRender: true });
	  };
	
	  CookieMessage.prototype.render = function render() {
	    var _props = this.props,
	        acceptedCookieNotice = _props.acceptedCookieNotice,
	        dismissCookieNotice = _props.dismissCookieNotice;
	    var shouldRender = this.state.shouldRender;
	
	
	    if (!acceptedCookieNotice && shouldRender) {
	      return _react2.default.createElement(
	        "div",
	        null,
	        _react2.default.createElement(
	          "div",
	          { className: _indexModule2.default.rootShow },
	          _react2.default.createElement(
	            "span",
	            { className: _indexModule2.default.text },
	            "This website uses cookies in order to provide you with a better experience. To find out more about cookies\xA0",
	            _react2.default.createElement(
	              _gatsbyLink2.default,
	              {
	                className: _indexModule2.default.link,
	                to: "/cookies",
	                target: "_blank",
	                rel: "noopener noreferrer"
	              },
	              "click here."
	            )
	          ),
	          _react2.default.createElement(
	            "div",
	            { className: _indexModule2.default.accept },
	            _react2.default.createElement(_ActionButton2.default, { label: "I accept", onClick: dismissCookieNotice })
	          )
	        )
	      );
	    }
	    // default to nothing for SSR
	    return null;
	  };
	
	  return CookieMessage;
	}(_react.Component);
	
	CookieMessage.propTypes = {
	  acceptedCookieNotice: _propTypes2.default.bool,
	  dismissCookieNotice: _propTypes2.default.func
	};
	
	exports.default = CookieMessage;
	module.exports = exports["default"];

/***/ }),

/***/ 600:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"root":"src-components-CookieMessage----index-module---root---G4_Pu","rootShow":"src-components-CookieMessage----index-module---rootShow---3ar6m src-components-CookieMessage----index-module---root---G4_Pu","text":"src-components-CookieMessage----index-module---text---2QI0g","accept":"src-components-CookieMessage----index-module---accept---3Diau","link":"src-components-CookieMessage----index-module---link---XFnZ8"};

/***/ }),

/***/ 456:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _reactRedux = __webpack_require__(6);
	
	var _ = __webpack_require__(457);
	
	var _2 = _interopRequireDefault(_);
	
	var _modal = __webpack_require__(20);
	
	var _user = __webpack_require__(125);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var withRedux = (0, _reactRedux.connect)(function (state) {
	  return {
	    email: (0, _user.getUser)(state).email
	  };
	}, function (dispatch) {
	  return {
	    onOk: function onOk() {
	      dispatch((0, _modal.hideModal)());
	    }
	  };
	});
	
	exports.default = withRedux(_2.default);
	module.exports = exports["default"];

/***/ }),

/***/ 457:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _indexModule = __webpack_require__(602);
	
	var _indexModule2 = _interopRequireDefault(_indexModule);
	
	var _ActionButton = __webpack_require__(77);
	
	var _ActionButton2 = _interopRequireDefault(_ActionButton);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var DownloadError = function DownloadError(_ref) {
	  var onOk = _ref.onOk;
	  return _react2.default.createElement(
	    "div",
	    { className: _indexModule2.default.root },
	    _react2.default.createElement(
	      "h1",
	      { className: _indexModule2.default.title },
	      "Oops!"
	    ),
	    _react2.default.createElement(
	      "p",
	      { className: _indexModule2.default.body },
	      "There was a problem downloading your report. Please try again later."
	    ),
	    _react2.default.createElement(
	      "div",
	      { className: _indexModule2.default.button },
	      _react2.default.createElement(_ActionButton2.default, { label: "OK", onClick: onOk })
	    )
	  );
	};
	
	DownloadError.defaultProps = {
	  email: "your address"
	};
	
	DownloadError.propTypes = {
	  email: _propTypes2.default.string,
	  onOk: _propTypes2.default.func
	};
	
	exports.default = DownloadError;
	module.exports = exports["default"];

/***/ }),

/***/ 602:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"root":"src-components-DownloadError----index-module---root---2_lPs","title":"src-components-DownloadError----index-module---title---3OTnt","body":"src-components-DownloadError----index-module---body---2gTAR","button":"src-components-DownloadError----index-module---button---3eIoy"};

/***/ }),

/***/ 458:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _reactRedux = __webpack_require__(6);
	
	var _ = __webpack_require__(459);
	
	var _2 = _interopRequireDefault(_);
	
	var _modal = __webpack_require__(20);
	
	var _user = __webpack_require__(125);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var withRedux = (0, _reactRedux.connect)(function (state) {
	  return {
	    user: (0, _user.getUser)(state)
	  };
	}, function (dispatch) {
	  return {
	    onSubmit: function onSubmit(values) {
	      dispatch((0, _modal.requestDownload)(values));
	    }
	  };
	});
	
	exports.default = withRedux(_2.default);
	module.exports = exports["default"];

/***/ }),

/***/ 459:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _gatsbyLink = __webpack_require__(10);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _indexModule = __webpack_require__(603);
	
	var _indexModule2 = _interopRequireDefault(_indexModule);
	
	var _ActionButton = __webpack_require__(77);
	
	var _ActionButton2 = _interopRequireDefault(_ActionButton);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var DownloadForm = function (_Component) {
	  _inherits(DownloadForm, _Component);
	
	  function DownloadForm(props) {
	    _classCallCheck(this, DownloadForm);
	
	    var _this = _possibleConstructorReturn(this, _Component.call(this, props));
	
	    _this.state = {
	      email: _this.props.user.email || "",
	      newsletter: _this.props.user.newsletter === false ? false : true,
	      termsAgreed: _this.props.user.termsAgreed || false,
	      isSubmitted: false
	    };
	    _this.handleInputChange = _this.handleInputChange.bind(_this);
	    _this.handleSubmit = _this.handleSubmit.bind(_this);
	    return _this;
	  }
	
	  DownloadForm.prototype.handleInputChange = function handleInputChange(e) {
	    var _setState;
	
	    var target = e.target;
	    var value = target.type === "checkbox" ? target.checked : target.value;
	    var name = target.name;
	
	    this.setState((_setState = {}, _setState[name] = value, _setState));
	  };
	
	  DownloadForm.prototype.handleSubmit = function handleSubmit(e) {
	    this.setState({ isSubmitted: true });
	    e.preventDefault();
	    this.props.onSubmit(this.state);
	  };
	
	  DownloadForm.prototype.render = function render() {
	    var _state = this.state,
	        email = _state.email,
	        termsAgreed = _state.termsAgreed,
	        newsletter = _state.newsletter,
	        isSubmitted = _state.isSubmitted;
	
	    var disabled = termsAgreed === false || email.length < 5 || !email.includes("@");
	    return _react2.default.createElement(
	      "div",
	      { className: _indexModule2.default.root },
	      _react2.default.createElement(
	        "h1",
	        { className: _indexModule2.default.title },
	        "Download Data"
	      ),
	      _react2.default.createElement(
	        "p",
	        { className: _indexModule2.default.body },
	        "Enter an email below to continue to download the file. You'll only need to enter it once, unless you delete your cookies, and we promise not to spam you (honest)"
	      ),
	      _react2.default.createElement(
	        "form",
	        { onSubmit: this.handleSubmit, className: _indexModule2.default.form },
	        _react2.default.createElement(
	          "div",
	          { className: _indexModule2.default.input },
	          _react2.default.createElement(
	            "label",
	            { htmlFor: "email", className: _indexModule2.default.inputLabel },
	            "Email address",
	            " "
	          ),
	          _react2.default.createElement("input", {
	            type: "email",
	            name: "email",
	            value: email,
	            onChange: this.handleInputChange,
	            className: _indexModule2.default.inputControl,
	            placeholder: "Your email (required)"
	          })
	        ),
	        _react2.default.createElement(
	          "div",
	          { className: _indexModule2.default.checkbox },
	          _react2.default.createElement(
	            "label",
	            { className: _indexModule2.default.checkboxLabel },
	            _react2.default.createElement("input", {
	              name: "termsAgreed",
	              type: "checkbox",
	              checked: termsAgreed,
	              onChange: this.handleInputChange,
	              className: _indexModule2.default.checkboxControl
	            }),
	            _react2.default.createElement(
	              "span",
	              { style: { display: "inline-block" } },
	              "I agree to the\xA0",
	              _react2.default.createElement(
	                _gatsbyLink2.default,
	                {
	                  className: _indexModule2.default.link,
	                  to: "/terms",
	                  target: "_blank",
	                  rel: "noopener noreferrer"
	                },
	                "terms and conditions",
	                " "
	              ),
	              " ",
	              _react2.default.createElement(
	                "span",
	                { className: _indexModule2.default.required },
	                "(required)"
	              )
	            )
	          )
	        ),
	        _react2.default.createElement(
	          "div",
	          { className: _indexModule2.default.checkbox },
	          _react2.default.createElement(
	            "label",
	            { className: _indexModule2.default.checkboxLabel },
	            _react2.default.createElement("input", {
	              name: "newsletter",
	              type: "checkbox",
	              checked: newsletter,
	              onChange: this.handleInputChange,
	              className: _indexModule2.default.checkboxControl
	            }),
	            "Please subscribe me to the Atomico mailing list"
	          )
	        ),
	        _react2.default.createElement(
	          "div",
	          { className: _indexModule2.default.submit },
	          !isSubmitted && _react2.default.createElement(_ActionButton2.default, { disabled: disabled }),
	          isSubmitted && _react2.default.createElement(
	            "span",
	            { className: _indexModule2.default.loadingText },
	            "Loading.."
	          )
	        )
	      )
	    );
	  };
	
	  return DownloadForm;
	}(_react.Component);
	
	DownloadForm.defaultProps = {
	  user: {}
	};
	
	DownloadForm.propTypes = {
	  user: _propTypes2.default.shape({
	    email: _propTypes2.default.string,
	    termsAgreed: _propTypes2.default.bool,
	    newsletter: _propTypes2.default.bool
	  }),
	  onSubmit: _propTypes2.default.func
	};
	
	exports.default = DownloadForm;
	module.exports = exports["default"];

/***/ }),

/***/ 603:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"root":"src-components-DownloadForm----index-module---root---1gWcC","title":"src-components-DownloadForm----index-module---title---1Y1Xn","body":"src-components-DownloadForm----index-module---body---2PJPS","form":"src-components-DownloadForm----index-module---form---3fIK0","inputLabel":"src-components-DownloadForm----index-module---inputLabel---3WzYY","inputControl":"src-components-DownloadForm----index-module---inputControl---sSW59","checkbox":"src-components-DownloadForm----index-module---checkbox---1xGA4","checkboxLabel":"src-components-DownloadForm----index-module---checkboxLabel---UwLzJ","required":"src-components-DownloadForm----index-module---required---3B-zF","checkboxControl":"src-components-DownloadForm----index-module---checkboxControl---3AAoF","link":"src-components-DownloadForm----index-module---link---2imbh","submit":"src-components-DownloadForm----index-module---submit---3h7tQ","loadingText":"src-components-DownloadForm----index-module---loadingText---3L7u2"};

/***/ }),

/***/ 460:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _reactRedux = __webpack_require__(6);
	
	var _ = __webpack_require__(461);
	
	var _2 = _interopRequireDefault(_);
	
	var _modal = __webpack_require__(20);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// import { getUser } from "../../state/user";
	
	var withRedux = (0, _reactRedux.connect)(function () {
	  return {
	    // email: getUser(state).email
	  };
	}, function (dispatch) {
	  return {
	    onOk: function onOk() {
	      dispatch((0, _modal.hideModal)());
	    }
	  };
	});
	
	exports.default = withRedux(_2.default);
	module.exports = exports["default"];

/***/ }),

/***/ 461:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _indexModule = __webpack_require__(604);
	
	var _indexModule2 = _interopRequireDefault(_indexModule);
	
	var _ActionButton = __webpack_require__(77);
	
	var _ActionButton2 = _interopRequireDefault(_ActionButton);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var DownloadSuccess = function DownloadSuccess(_ref) {
	  var onOk = _ref.onOk,
	      text = _ref.text;
	  return _react2.default.createElement(
	    "div",
	    { className: _indexModule2.default.root },
	    _react2.default.createElement(
	      "h1",
	      { className: _indexModule2.default.title },
	      "Thank You"
	    ),
	    _react2.default.createElement(
	      "p",
	      { className: _indexModule2.default.body },
	      text ? text : _react2.default.createElement(
	        "span",
	        null,
	        "Your download will start in a few moments. Check your browser",
	        "'",
	        "s download folder."
	      )
	    ),
	    _react2.default.createElement(
	      "div",
	      { className: _indexModule2.default.button },
	      _react2.default.createElement(_ActionButton2.default, { label: "OK", onClick: onOk })
	    )
	  );
	};
	
	DownloadSuccess.defaultProps = {
	  email: "your address"
	};
	
	DownloadSuccess.propTypes = {
	  // email: PropTypes.string,
	  text: _propTypes2.default.string,
	  onOk: _propTypes2.default.func
	};
	
	exports.default = DownloadSuccess;
	module.exports = exports["default"];

/***/ }),

/***/ 604:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"root":"src-components-DownloadSuccess----index-module---root---2fG5U","title":"src-components-DownloadSuccess----index-module---title---2t3Yz","body":"src-components-DownloadSuccess----index-module---body---25okk","button":"src-components-DownloadSuccess----index-module---button---2pslK"};

/***/ }),

/***/ 342:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * An SVG icon. Stroke and fill can be supplied as props OR applied via CSS
	 * using the className prop.
	 *
	 * @param {string} className  A classname to be applied to the element
	 * @param {string} stroke     A colour
	 * @param {string} fill       A colour
	 */
	var FilterIcon = function FilterIcon(_ref) {
	  var className = _ref.className,
	      stroke = _ref.stroke,
	      fill = _ref.fill;
	
	  return _react2.default.createElement(
	    "span",
	    { className: className },
	    _react2.default.createElement(
	      "svg",
	      {
	        xmlns: "http://www.w3.org/2000/svg",
	        width: "22",
	        height: "18",
	        viewBox: "0 0 22 16"
	      },
	      _react2.default.createElement(
	        "g",
	        { fill: "none", fillRule: "evenodd" },
	        _react2.default.createElement("path", { stroke: stroke, d: "M0 2.034h22" }),
	        _react2.default.createElement("ellipse", { cx: "4.132", cy: "2.034", fill: fill, rx: "2.037", ry: "2.034" }),
	        _react2.default.createElement(
	          "g",
	          { transform: "translate(0 5.696)" },
	          _react2.default.createElement("path", { stroke: stroke, d: "M0 2.034h22" }),
	          _react2.default.createElement("ellipse", { cx: "16.818", cy: "2.034", fill: fill, rx: "2.037", ry: "2.034" })
	        ),
	        _react2.default.createElement(
	          "g",
	          { transform: "translate(0 11.392)" },
	          _react2.default.createElement("path", { stroke: stroke, d: "M0 2.034h22" }),
	          _react2.default.createElement("ellipse", { cx: "10.287", cy: "2.034", fill: fill, rx: "2.037", ry: "2.034" })
	        )
	      )
	    )
	  );
	};
	
	FilterIcon.propTypes = {
	  className: _propTypes2.default.string,
	  fill: _propTypes2.default.string,
	  stroke: _propTypes2.default.string
	};
	
	exports.default = FilterIcon;
	module.exports = exports["default"];

/***/ }),

/***/ 470:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactTransitionGroup = __webpack_require__(333);
	
	var _container = __webpack_require__(476);
	
	var _container2 = _interopRequireDefault(_container);
	
	var _container3 = __webpack_require__(474);
	
	var _container4 = _interopRequireDefault(_container3);
	
	var _indexModule = __webpack_require__(609);
	
	var _indexModule2 = _interopRequireDefault(_indexModule);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var LayoutNav = function (_Component) {
	  _inherits(LayoutNav, _Component);
	
	  function LayoutNav(props) {
	    _classCallCheck(this, LayoutNav);
	
	    var _this = _possibleConstructorReturn(this, _Component.call(this, props));
	
	    _this.state = {
	      navOpen: false,
	      chapters: props.chapters
	    };
	    _this.onNavOpen = _this.onNavOpen.bind(_this);
	    _this.onNavClose = _this.onNavClose.bind(_this);
	    return _this;
	  }
	
	  LayoutNav.prototype.onNavOpen = function onNavOpen() {
	    this.setState({ navOpen: true });
	  };
	
	  LayoutNav.prototype.onNavClose = function onNavClose() {
	    this.setState({ navOpen: false });
	  };
	
	  LayoutNav.prototype.render = function render() {
	    var _this2 = this;
	
	    var chapters = this.state.chapters;
	    // Use this to trigger a re-render in the NavDrawer when the location
	    // changes.
	
	    var currentPath = this.props.currentPath;
	
	
	    return _react2.default.createElement(
	      "div",
	      { className: _indexModule2.default.root },
	      _react2.default.createElement(
	        "div",
	        { className: _indexModule2.default.handle },
	        _react2.default.createElement(_container2.default, {
	          onNavOpen: this.onNavOpen,
	          isOpen: this.state.navOpen,
	          chapters: chapters
	        }),
	        _react2.default.createElement(
	          _reactTransitionGroup.Transition,
	          { "in": this.state.navOpen, timeout: 600 },
	          function (state) {
	            return _react2.default.createElement(
	              "div",
	              null,
	              _react2.default.createElement("div", { className: _indexModule2.default["wrapper" + state] }),
	              _react2.default.createElement(
	                "div",
	                { className: _indexModule2.default["drawer" + state] },
	                _react2.default.createElement(
	                  "div",
	                  { className: _indexModule2.default.drawerInner },
	                  _react2.default.createElement(_container4.default, {
	                    onNavClose: _this2.onNavClose,
	                    chapters: chapters,
	                    currentPath: currentPath
	                  })
	                )
	              )
	            );
	          }
	        )
	      )
	    );
	  };
	
	  return LayoutNav;
	}(_react.Component);
	
	LayoutNav.propTypes = {
	  currentPath: _propTypes2.default.string,
	  chapters: _propTypes2.default.arrayOf(_propTypes2.default.shape({
	    path: _propTypes2.default.string,
	    title: _propTypes2.default.string,
	    titleNumber: _propTypes2.default.string
	  }))
	};
	
	exports.default = LayoutNav;
	module.exports = exports["default"];

/***/ }),

/***/ 609:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"root":"src-components-LayoutNav----index-module---root---2NS1I","handle":"src-components-LayoutNav----index-module---handle---2i37O","wrapper":"src-components-LayoutNav----index-module---wrapper---1Y8bC","wrapperexited":"src-components-LayoutNav----index-module---wrapperexited---28Yb9 src-components-LayoutNav----index-module---wrapper---1Y8bC","wrapperentering":"src-components-LayoutNav----index-module---wrapperentering---1e7Fn src-components-LayoutNav----index-module---wrapper---1Y8bC","wrapperentered":"src-components-LayoutNav----index-module---wrapperentered---3B0Y6 src-components-LayoutNav----index-module---wrapper---1Y8bC","wrapperexiting":"src-components-LayoutNav----index-module---wrapperexiting---1kzQt src-components-LayoutNav----index-module---wrapper---1Y8bC","drawer":"src-components-LayoutNav----index-module---drawer---1O4pF","drawerexited":"src-components-LayoutNav----index-module---drawerexited---ndeSK src-components-LayoutNav----index-module---drawer---1O4pF src-components-LayoutNav----index-module---drawer---1O4pF","drawerentering":"src-components-LayoutNav----index-module---drawerentering---ZhlMf src-components-LayoutNav----index-module---drawer---1O4pF src-components-LayoutNav----index-module---drawer---1O4pF","drawerentered":"src-components-LayoutNav----index-module---drawerentered---2yR_S src-components-LayoutNav----index-module---drawer---1O4pF src-components-LayoutNav----index-module---drawer---1O4pF","drawerexiting":"src-components-LayoutNav----index-module---drawerexiting---3kFWb src-components-LayoutNav----index-module---drawer---1O4pF src-components-LayoutNav----index-module---drawer---1O4pF"};

/***/ }),

/***/ 471:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _indexModule = __webpack_require__(610);
	
	var _indexModule2 = _interopRequireDefault(_indexModule);
	
	var _CloseButton = __webpack_require__(340);
	
	var _CloseButton2 = _interopRequireDefault(_CloseButton);
	
	var _reactModal = __webpack_require__(901);
	
	var _reactModal2 = _interopRequireDefault(_reactModal);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Modal = function Modal(_ref) {
	  var onAfterOpen = _ref.onAfterOpen,
	      onRequestClose = _ref.onRequestClose,
	      isOpen = _ref.isOpen,
	      children = _ref.children;
	  return _react2.default.createElement(
	    _reactModal2.default,
	    {
	      className: _indexModule2.default.content,
	      closeTimeoutMS: 200,
	      contentLabel: "Modal",
	      isOpen: isOpen,
	      onAfterOpen: onAfterOpen,
	      onRequestClose: onRequestClose,
	      overlayClassName: {
	        base: _indexModule2.default.overlay,
	        afterOpen: _indexModule2.default.overlayAfterOpen,
	        beforeClose: _indexModule2.default.overlayBeforeClose
	      },
	      parentSelector: function parentSelector() {
	        return document.body;
	      },
	      shouldCloseOnOverlayClick: true
	    },
	    _react2.default.createElement(
	      "div",
	      { className: _indexModule2.default.button },
	      _react2.default.createElement(_CloseButton2.default, { inverted: true, onClick: onRequestClose })
	    ),
	    children
	  );
	};
	
	Modal.propTypes = {
	  isOpen: _propTypes2.default.bool,
	  onAfterOpen: _propTypes2.default.func,
	  onRequestClose: _propTypes2.default.func
	};
	
	exports.default = Modal;
	module.exports = exports["default"];

/***/ }),

/***/ 610:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"overlay":"src-components-Modal----index-module---overlay---2K-Qm","overlayAfterOpen":"src-components-Modal----index-module---overlayAfterOpen---3UUDK","overlayBeforeClose":"src-components-Modal----index-module---overlayBeforeClose---2fRPF","content":"src-components-Modal----index-module---content---2i_if","button":"src-components-Modal----index-module---button---sdjNj"};

/***/ }),

/***/ 472:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _reactRedux = __webpack_require__(6);
	
	var _ModalRoot = __webpack_require__(473);
	
	var _ModalRoot2 = _interopRequireDefault(_ModalRoot);
	
	var _modal = __webpack_require__(20);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var withRedux = (0, _reactRedux.connect)(function (state) {
	  return {
	    modal: (0, _modal.getModal)(state)
	  };
	}, function (dispatch) {
	  return {
	    onClose: function onClose() {
	      dispatch((0, _modal.hideModal)());
	    }
	  };
	});
	
	exports.default = withRedux(_ModalRoot2.default);
	module.exports = exports["default"];

/***/ }),

/***/ 473:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _modalComponents;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _Modal = __webpack_require__(471);
	
	var _Modal2 = _interopRequireDefault(_Modal);
	
	var _container = __webpack_require__(458);
	
	var _container2 = _interopRequireDefault(_container);
	
	var _container3 = __webpack_require__(460);
	
	var _container4 = _interopRequireDefault(_container3);
	
	var _container5 = __webpack_require__(456);
	
	var _container6 = _interopRequireDefault(_container5);
	
	var _modal = __webpack_require__(20);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var modalComponents = (_modalComponents = {}, _modalComponents[_modal.modals.DOWNLOAD_SAVED_ARTICLES] = _container2.default, _modalComponents[_modal.modals.DOWNLOAD_FILTERED_ARTICLES] = _container2.default, _modalComponents[_modal.modals.DOWNLOAD_REPORT] = _container2.default, _modalComponents[_modal.modals.DOWNLOAD_CHART] = _container2.default, _modalComponents[_modal.modals.DOWNLOAD_SUCCESS] = _container4.default, _modalComponents[_modal.modals.DOWNLOAD_ERROR] = _container6.default, _modalComponents);
	
	var ModalRoot = function ModalRoot(_ref) {
	  var modal = _ref.modal,
	      onClose = _ref.onClose;
	  var isOpen = modal.isOpen,
	      modalType = modal.modalType,
	      modalProps = modal.modalProps;
	
	  var ModalInner = modalComponents[modalType] || "div";
	
	  return _react2.default.createElement(
	    _Modal2.default,
	    { onRequestClose: onClose, isOpen: isOpen },
	    _react2.default.createElement(ModalInner, modalProps)
	  );
	};
	
	ModalRoot.propTypes = {
	  modal: _propTypes2.default.shape({
	    isOpen: _propTypes2.default.bool,
	    modalType: _propTypes2.default.symbol, // can't check for specific Symbols due to https://github.com/facebook/prop-types/issues/10
	    modalProps: _propTypes2.default.shape({}) // can be anything
	  }),
	  onClose: _propTypes2.default.func
	};
	
	exports.default = ModalRoot;
	module.exports = exports["default"];

/***/ }),

/***/ 474:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _reactRedux = __webpack_require__(6);
	
	var _NavDrawer = __webpack_require__(475);
	
	var _NavDrawer2 = _interopRequireDefault(_NavDrawer);
	
	var _save = __webpack_require__(81);
	
	var _modal = __webpack_require__(20);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var withRedux = (0, _reactRedux.connect)(function (state) {
	  return {
	    savedArticleCount: (0, _save.getSavedCount)(state)
	  };
	}, function (dispatch) {
	  return {
	    onDownloadClick: function onDownloadClick() {
	      var modal = {
	        modalType: _modal.modals.DOWNLOAD_REPORT,
	        modalProps: {}
	      };
	      dispatch((0, _modal.showModal)(modal));
	    }
	  };
	});
	
	exports.default = withRedux(_NavDrawer2.default);
	module.exports = exports["default"];

/***/ }),

/***/ 475:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _gatsbyLink = __webpack_require__(10);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _indexModule = __webpack_require__(611);
	
	var _indexModule2 = _interopRequireDefault(_indexModule);
	
	var _Share = __webpack_require__(124);
	
	var _CloseButton = __webpack_require__(340);
	
	var _CloseButton2 = _interopRequireDefault(_CloseButton);
	
	var _ActionButton = __webpack_require__(77);
	
	var _ActionButton2 = _interopRequireDefault(_ActionButton);
	
	var _SaveIcon = __webpack_require__(284);
	
	var _SaveIcon2 = _interopRequireDefault(_SaveIcon);
	
	var _FilterIcon = __webpack_require__(342);
	
	var _FilterIcon2 = _interopRequireDefault(_FilterIcon);
	
	var _sharingConfig = __webpack_require__(286);
	
	var _sharingConfig2 = _interopRequireDefault(_sharingConfig);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var onLinkClick = function onLinkClick(e, path, navClose) {
	  e.preventDefault();
	  navClose();
	  setTimeout(function () {
	    return (0, _gatsbyLink.navigateTo)(path);
	  }, 300);
	};
	
	var NavDrawer = function NavDrawer(_ref) {
	  var onNavClose = _ref.onNavClose,
	      chapters = _ref.chapters,
	      savedArticleCount = _ref.savedArticleCount,
	      onDownloadClick = _ref.onDownloadClick;
	
	  var savedCountLabel = savedArticleCount ? "" + savedArticleCount : "0";
	  var shareUrl = _sharingConfig2.default.defaultShareUrl;
	  var linkedInShareText = _sharingConfig2.default.defaultShareTextLinkedin;
	  var shareText = _sharingConfig2.default.defaultShareTextTwitter;
	  var twitterShareText = shareText + " " + shareUrl;
	  return _react2.default.createElement(
	    "nav",
	    { className: _indexModule2.default.root },
	    _react2.default.createElement(
	      "div",
	      { className: _indexModule2.default.inner },
	      _react2.default.createElement(
	        "div",
	        { className: _indexModule2.default.header },
	        _react2.default.createElement(
	          _gatsbyLink2.default,
	          { to: "/", className: _indexModule2.default.title, onClick: onNavClose },
	          "The State of European Tech 2017"
	        ),
	        _react2.default.createElement(
	          "div",
	          { className: _indexModule2.default.button },
	          _react2.default.createElement(_CloseButton2.default, { onClick: onNavClose })
	        )
	      ),
	      _react2.default.createElement(
	        "ul",
	        { className: _indexModule2.default.navList },
	        chapters.map(function (chapter) {
	          return _react2.default.createElement(
	            "li",
	            { key: chapter.titleNumber, className: _indexModule2.default.navItem },
	            _react2.default.createElement(
	              _gatsbyLink2.default,
	              {
	                className: _indexModule2.default.navLink,
	                activeClassName: _indexModule2.default.navLinkActive,
	                to: chapter.path,
	                onClick: function onClick(e) {
	                  onLinkClick(e, chapter.path, onNavClose);
	                }
	              },
	              _react2.default.createElement(
	                "span",
	                { className: _indexModule2.default.navLinkBullet },
	                chapter.titleNumber
	              ),
	              chapter.title
	            )
	          );
	        }),
	        _react2.default.createElement(
	          "li",
	          { key: "savedArticles", className: _indexModule2.default.navItemSpecial },
	          _react2.default.createElement(
	            _gatsbyLink2.default,
	            {
	              className: _indexModule2.default.navLink,
	              activeClassName: _indexModule2.default.navLinkActive,
	              to: "/saved/",
	              onClick: onNavClose
	            },
	            _react2.default.createElement(
	              "span",
	              { className: _indexModule2.default.navLinkBullet },
	              _react2.default.createElement(_SaveIcon2.default, { stroke: "currentColor", fill: "transparent" })
	            ),
	            "Saved (",
	            savedCountLabel,
	            ")"
	          )
	        ),
	        _react2.default.createElement(
	          "li",
	          { key: "filterArticles", className: _indexModule2.default.navItemSpecial },
	          _react2.default.createElement(
	            _gatsbyLink2.default,
	            {
	              className: _indexModule2.default.navLink,
	              activeClassName: _indexModule2.default.navLinkActive,
	              to: "/filter/",
	              onClick: onNavClose
	            },
	            _react2.default.createElement(
	              "span",
	              { className: _indexModule2.default.navLinkBullet },
	              _react2.default.createElement(_FilterIcon2.default, { stroke: "currentColor", fill: "currentColor" })
	            ),
	            "Filter report"
	          )
	        )
	      ),
	      _react2.default.createElement(
	        "div",
	        { className: _indexModule2.default.actions },
	        _react2.default.createElement(
	          "div",
	          null,
	          _react2.default.createElement(_ActionButton2.default, {
	            onClick: onDownloadClick,
	            label: "Download Report",
	            large: true
	          })
	        ),
	        _react2.default.createElement(
	          "div",
	          { className: _indexModule2.default.actionShare },
	          _react2.default.createElement(
	            "div",
	            { className: _indexModule2.default.action },
	            _react2.default.createElement(_Share.ShareLinkedIn, { url: shareUrl, title: linkedInShareText })
	          ),
	          _react2.default.createElement(
	            "div",
	            { className: _indexModule2.default.action },
	            _react2.default.createElement(_Share.ShareTwitter, { text: twitterShareText })
	          )
	        )
	      )
	    )
	  );
	};
	
	NavDrawer.propTypes = {
	  onNavClose: _propTypes2.default.func.isRequired,
	  onDownloadClick: _propTypes2.default.func,
	  savedArticleCount: _propTypes2.default.number,
	  chapters: _propTypes2.default.arrayOf(_propTypes2.default.shape({
	    titleNumber: _propTypes2.default.string,
	    path: _propTypes2.default.string
	  }))
	};
	
	exports.default = NavDrawer;
	module.exports = exports["default"];

/***/ }),

/***/ 611:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"root":"src-components-NavDrawer----index-module---root---17UIq","inner":"src-components-NavDrawer----index-module---inner---321G_","header":"src-components-NavDrawer----index-module---header---3zTzd","title":"src-components-NavDrawer----index-module---title---3R0Xp","button":"src-components-NavDrawer----index-module---button---x9kdZ","navList":"src-components-NavDrawer----index-module---navList---14MUT","navItem":"src-components-NavDrawer----index-module---navItem---1GAOl","navItemSpecial":"src-components-NavDrawer----index-module---navItemSpecial---oOCK9 src-components-NavDrawer----index-module---navItem---1GAOl","navLink":"src-components-NavDrawer----index-module---navLink---1rHMh","navLinkActive":"src-components-NavDrawer----index-module---navLinkActive---3RzHC","navLinkBullet":"src-components-NavDrawer----index-module---navLinkBullet---3k72p","actions":"src-components-NavDrawer----index-module---actions---1vA1B","action":"src-components-NavDrawer----index-module---action---2gi9-","actionShare":"src-components-NavDrawer----index-module---actionShare---20YND"};

/***/ }),

/***/ 882:
/***/ (function(module, exports) {

	module.exports = "<svg xmlns=\"http://www.w3.org/2000/svg\" width=\"12\" height=\"18\" viewBox=\"0 0 12 18\">\n  <polyline fill=\"none\" stroke=\"#FFF\" points=\"18.646 16.349 7 8.175 18.646 0\" transform=\"translate(-7 1)\"/>\n</svg>\n"

/***/ }),

/***/ 883:
/***/ (function(module, exports) {

	module.exports = "<svg xmlns=\"http://www.w3.org/2000/svg\" width=\"24\" height=\"18\" viewBox=\"0 0 24 18\"><path d=\"M0 .98h24M0 8.97h24M0 16.96h24\" fill=\"none\" fill-rule=\"evenodd\"/></svg>"

/***/ }),

/***/ 476:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _reactRedux = __webpack_require__(6);
	
	var _ = __webpack_require__(477);
	
	var _2 = _interopRequireDefault(_);
	
	var _navSection = __webpack_require__(33);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var withRedux = (0, _reactRedux.connect)(function (state) {
	  return {
	    navSection: (0, _navSection.getNavSection)(state)
	  };
	}, function () {
	  return {};
	});
	
	exports.default = withRedux(_2.default);
	module.exports = exports["default"];

/***/ }),

/***/ 477:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _backChevron = __webpack_require__(882);
	
	var _backChevron2 = _interopRequireDefault(_backChevron);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _gatsbyLink = __webpack_require__(10);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _reactSvgInline = __webpack_require__(9);
	
	var _reactSvgInline2 = _interopRequireDefault(_reactSvgInline);
	
	var _reactTransitionGroup = __webpack_require__(333);
	
	var _burgerIcon = __webpack_require__(883);
	
	var _burgerIcon2 = _interopRequireDefault(_burgerIcon);
	
	var _indexModule = __webpack_require__(612);
	
	var _indexModule2 = _interopRequireDefault(_indexModule);
	
	var _SaveIcon = __webpack_require__(284);
	
	var _SaveIcon2 = _interopRequireDefault(_SaveIcon);
	
	var _FilterIcon = __webpack_require__(342);
	
	var _FilterIcon2 = _interopRequireDefault(_FilterIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var NavHandle = function NavHandle(_ref) {
	  var onNavOpen = _ref.onNavOpen,
	      isOpen = _ref.isOpen,
	      children = _ref.children,
	      chapters = _ref.chapters,
	      navSection = _ref.navSection;
	
	  var sectionTitle = void 0;
	  var backUrl = void 0;
	  if (navSection) {
	    sectionTitle = navSection.title;
	    backUrl = navSection.backUrl;
	  }
	
	  return _react2.default.createElement(
	    "div",
	    { className: _indexModule2.default.root },
	    _react2.default.createElement(
	      "h1",
	      { className: _indexModule2.default["title" + (isOpen ? "Open" : "")] },
	      sectionTitle || "Menu"
	    ),
	    _react2.default.createElement(
	      _reactTransitionGroup.Transition,
	      { "in": !isOpen, timeout: 200 },
	      function (state) {
	        return _react2.default.createElement(
	          "nav",
	          { className: _indexModule2.default["nav" + state] },
	          _react2.default.createElement(
	            "div",
	            { className: _indexModule2.default.chapters },
	            chapters.map(function (chapter) {
	              return _react2.default.createElement(
	                _gatsbyLink2.default,
	                {
	                  key: chapter.titleNumber,
	                  to: chapter.path,
	                  className: _indexModule2.default.link,
	                  activeClassName: _indexModule2.default.linkActive
	                },
	                chapter.titleNumber
	              );
	            })
	          ),
	          _react2.default.createElement(
	            "div",
	            { className: _indexModule2.default.savedArticles },
	            _react2.default.createElement(
	              _gatsbyLink2.default,
	              {
	                to: "/saved/",
	                className: _indexModule2.default.link,
	                activeClassName: _indexModule2.default.linkActive
	              },
	              _react2.default.createElement(_SaveIcon2.default, { className: _indexModule2.default.linkSvg, component: "<div>" })
	            )
	          ),
	          _react2.default.createElement(
	            "div",
	            { className: _indexModule2.default.filterArticles },
	            _react2.default.createElement(
	              _gatsbyLink2.default,
	              {
	                to: "/filter/",
	                className: _indexModule2.default.link,
	                activeClassName: _indexModule2.default.linkActive
	              },
	              _react2.default.createElement(_FilterIcon2.default, {
	                className: _indexModule2.default.linkSvgFilter,
	                fill: "currentColor",
	                stroke: "currentColor",
	                component: "<div>"
	              })
	            )
	          )
	        );
	      }
	    ),
	    backUrl && _react2.default.createElement(
	      _gatsbyLink2.default,
	      {
	        key: "backbutton",
	        to: backUrl,
	        alt: "Back to " + sectionTitle + " overview",
	        className: _indexModule2.default.back
	      },
	      _react2.default.createElement(_reactSvgInline2.default, {
	        className: _indexModule2.default.backSvg,
	        svg: _backChevron2.default,
	        cleanup: ["fill"],
	        fill: "none"
	      })
	    ),
	    _react2.default.createElement(
	      "button",
	      { className: _indexModule2.default.button, onClick: onNavOpen },
	      _react2.default.createElement(
	        "span",
	        { className: _indexModule2.default.buttonInner },
	        _react2.default.createElement(_reactSvgInline2.default, {
	          className: _indexModule2.default.burgerIcon,
	          svg: _burgerIcon2.default,
	          cleanup: ["fill"]
	        })
	      )
	    ),
	    children
	  );
	};
	
	NavHandle.propTypes = {
	  onNavOpen: _propTypes2.default.func.isRequired,
	  isOpen: _propTypes2.default.bool,
	  chapters: _propTypes2.default.arrayOf(_propTypes2.default.shape({
	    titleNumber: _propTypes2.default.string,
	    path: _propTypes2.default.string
	  })),
	  title: _propTypes2.default.string,
	  navSection: _propTypes2.default.shape({
	    backUrl: _propTypes2.default.oneOfType([_propTypes2.default.bool, _propTypes2.default.string]),
	    title: _propTypes2.default.oneOfType([_propTypes2.default.bool, _propTypes2.default.string])
	  })
	};
	
	exports.default = NavHandle;
	module.exports = exports["default"];

/***/ }),

/***/ 612:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"root":"src-components-NavHandle----index-module---root---3eFFS","title":"src-components-NavHandle----index-module---title---YITbT","titleOpen":"src-components-NavHandle----index-module---titleOpen---18POZ src-components-NavHandle----index-module---title---YITbT","back":"src-components-NavHandle----index-module---back---2q6S9","button":"src-components-NavHandle----index-module---button---2RzLg","burgerIcon":"src-components-NavHandle----index-module---burgerIcon---x4cPI","nav":"src-components-NavHandle----index-module---nav---3-RYG","naventering":"src-components-NavHandle----index-module---naventering---6rSHv src-components-NavHandle----index-module---nav---3-RYG","naventered":"src-components-NavHandle----index-module---naventered---1x59L src-components-NavHandle----index-module---nav---3-RYG","navexiting":"src-components-NavHandle----index-module---navexiting---15FAi src-components-NavHandle----index-module---nav---3-RYG","navexited":"src-components-NavHandle----index-module---navexited---3plXJ src-components-NavHandle----index-module---nav---3-RYG","chapters":"src-components-NavHandle----index-module---chapters---2X5ve","link":"src-components-NavHandle----index-module---link---KA_Ak","linkActive":"src-components-NavHandle----index-module---linkActive---37x2R","linkSvg":"src-components-NavHandle----index-module---linkSvg---3ZRMp","linkSvgFilter":"src-components-NavHandle----index-module---linkSvgFilter---mLX22 src-components-NavHandle----index-module---linkSvg---3ZRMp","savedArticles":"src-components-NavHandle----index-module---savedArticles---36NSJ"};

/***/ }),

/***/ 626:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),

/***/ 489:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	exports.layoutQuery = undefined;
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactDom = __webpack_require__(99);
	
	var _reactTransitionGroup = __webpack_require__(333);
	
	var _withRouter = __webpack_require__(330);
	
	var _withRouter2 = _interopRequireDefault(_withRouter);
	
	var _Banner = __webpack_require__(450);
	
	var _Banner2 = _interopRequireDefault(_Banner);
	
	var _container = __webpack_require__(453);
	
	var _container2 = _interopRequireDefault(_container);
	
	var _LayoutHead = __webpack_require__(78);
	
	var _LayoutHead2 = _interopRequireDefault(_LayoutHead);
	
	var _LayoutNav = __webpack_require__(470);
	
	var _LayoutNav2 = _interopRequireDefault(_LayoutNav);
	
	var _container3 = __webpack_require__(472);
	
	var _container4 = _interopRequireDefault(_container3);
	
	var _transitionDirection2 = __webpack_require__(505);
	
	var _transitionDirection3 = _interopRequireDefault(_transitionDirection2);
	
	var _sharingConfig = __webpack_require__(286);
	
	var _sharingConfig2 = _interopRequireDefault(_sharingConfig);
	
	__webpack_require__(626);
	
	var _indexModule = __webpack_require__(622);
	
	var _indexModule2 = _interopRequireDefault(_indexModule);
	
	var _transitionsModule = __webpack_require__(623);
	
	var _transitionsModule2 = _interopRequireDefault(_transitionsModule);
	
	var _gatsbyLink = __webpack_require__(10);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	/* A masking element, uses React's Portals to allow a component to sit 'above'
	 * the rest of the app. Used to mask out areas of the screen during animations.
	 */
	var Mask = function (_React$Component) {
	  _inherits(Mask, _React$Component);
	
	  function Mask(props) {
	    _classCallCheck(this, Mask);
	
	    var _this = _possibleConstructorReturn(this, _React$Component.call(this, props));
	
	    _this.el = document.createElement("div");
	    return _this;
	  }
	
	  Mask.prototype.componentDidMount = function componentDidMount() {
	    // Append the element into the DOM on mount
	    var maskRoot = document.getElementById("maskRoot");
	    maskRoot.appendChild(this.el);
	  };
	
	  Mask.prototype.componentWillUnmount = function componentWillUnmount() {
	    // Remove the element from the DOM when we unmount
	    var maskRoot = document.getElementById("maskRoot");
	    maskRoot.removeChild(this.el);
	  };
	
	  Mask.prototype.render = function render() {
	    // Use a portal to render the children into the element
	    return (0, _reactDom.createPortal)(
	    // Any valid React child: JSX, strings, arrays, etc.
	    this.props.children,
	    // A DOM element
	    this.el);
	  };
	
	  return Mask;
	}(_react2.default.Component);
	
	var TransitionHandler = function (_React$Component2) {
	  _inherits(TransitionHandler, _React$Component2);
	
	  function TransitionHandler() {
	    _classCallCheck(this, TransitionHandler);
	
	    return _possibleConstructorReturn(this, _React$Component2.apply(this, arguments));
	  }
	
	  TransitionHandler.prototype.shouldComponentUpdate = function shouldComponentUpdate() {
	    // if (this.props.location.pathname !== window.location.pathname) {
	    //   console.log( "props.location - window.location", this.props.location.pathname, window.location.pathname );
	    // }
	    return this.props.location.pathname === window.location.pathname;
	  };
	
	  TransitionHandler.prototype.render = function render() {
	    return this.props.children;
	  };
	
	  return TransitionHandler;
	}(_react2.default.Component);
	
	TransitionHandler.propTypes = {
	  location: _propTypes2.default.shape({ pathname: _propTypes2.default.string })
	};
	
	/* Extract basic chapter data from an array of GraphQl edge objects */
	var getChaptersFromEdges = function getChaptersFromEdges(edges) {
	  return edges.map(function (edge) {
	    return {
	      path: edge.node.path,
	      title: edge.node.title,
	      titleNumber: edge.node.titleNumber
	    };
	  });
	};
	
	var Layout = function (_Component) {
	  _inherits(Layout, _Component);
	
	  function Layout(props) {
	    _classCallCheck(this, Layout);
	
	    var _this3 = _possibleConstructorReturn(this, _Component.call(this, props));
	
	    _this3.maskStyles = {
	      position: "fixed",
	      left: "60px",
	      width: "360px",
	      top: 0,
	      bottom: 0,
	      zIndex: 20
	    };
	
	    var chapterPaths = props.data.allSoetChapterNode.edges.map(function (edge) {
	      return {
	        prevPath: edge.node.prevPath,
	        nextPath: edge.node.nextPath,
	        childPath: edge.node.childPath,
	        path: edge.node.path,
	        chapterId: edge.node.chapterId
	      };
	    });
	    var articlePaths = props.data.allSoetArticleNode.edges.map(function (edge) {
	      return {
	        prevPath: edge.node.prevPath,
	        nextPath: edge.node.nextPath,
	        parentPath: edge.node.parentPath,
	        path: edge.node.path,
	        chapterId: edge.node.chapterId
	      };
	    });
	
	    // Setup paths used for kb / gesture navigation
	    var navChapterPaths = [].concat(chapterPaths);
	    // nextPath for chapter is blank, so 'next chapter' button is not displayed
	    // on chapter page.
	    // We want to allow kb nav to next section, so add a nextpath for usage
	    // in this copy of the paths
	    navChapterPaths[navChapterPaths.length - 1].nextPath = "/saved/";
	    var navPaths = [].concat(navChapterPaths, articlePaths, [
	    // add some hardcoded paths
	    {
	      path: "/",
	      nextPath: chapterPaths[0].path
	    }, {
	      prevPath: chapterPaths[chapterPaths.length - 1].path,
	      path: "/saved/",
	      nextPath: "/filter/"
	    }, {
	      prevPath: "/saved/",
	      path: "/filter/"
	    }]);
	
	    _this3.state = {
	      navOpen: false,
	      isArticleTransition: false,
	      transitionNames: {
	        enter: _transitionsModule2.default.downEnter,
	        enterActive: _transitionsModule2.default.downEnterActive,
	        exit: _transitionsModule2.default.downExit,
	        exitActive: _transitionsModule2.default.downExitActive
	      },
	      chapterPaths: chapterPaths,
	      articlePaths: articlePaths,
	      navPaths: navPaths,
	      chapters: getChaptersFromEdges(_this3.props.data.allSoetChapterNode.edges)
	    };
	    _this3.transitionChildFactory = _this3.transitionChildFactory.bind(_this3);
	    _this3.getChildContext = _this3.getChildContext.bind(_this3);
	    _this3.handleKeyDown = _this3.handleKeyDown.bind(_this3);
	    return _this3;
	  }
	
	  Layout.prototype.componentDidMount = function componentDidMount() {
	    window.addEventListener("keydown", this.handleKeyDown);
	  };
	
	  Layout.prototype.componentWillUnmount = function componentWillUnmount() {
	    window.removeEventListener("keydown", this.handleKeyDown);
	  };
	
	  Layout.prototype.handleKeyDown = function handleKeyDown(e) {
	    // e.which is deprecated, e.key is not fully supported so check both
	    var key = e.key;
	    var keyCode = e.which;
	    var isNavPress = ["ArrowLeft", "ArrowUp", "ArrowRight", "ArrowDown"].includes(key) || [37, 38, 39, 40].includes(keyCode);
	    if (!isNavPress) return;
	
	    var currLoc = this.props.location.pathname;
	    var paths = this.state.navPaths;
	    var matchedPath = paths.find(function (item) {
	      return item.path === currLoc;
	    });
	    if (!matchedPath) return;
	
	    var navType = false;
	    if (key === "ArrowLeft" || keyCode === 37) navType = "parentPath";
	    if (key === "ArrowUp" || keyCode === 38) navType = "prevPath";
	    if (key === "ArrowRight" || keyCode === 39) navType = "childPath";
	    if (key === "ArrowDown" || keyCode === 40) navType = "nextPath";
	    if (navType && matchedPath[navType]) (0, _gatsbyLink.navigateTo)(matchedPath[navType]);
	  };
	
	  Layout.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
	    var currLoc = this.props.location.pathname;
	    var nextLoc = nextProps.location.pathname;
	    if (currLoc === nextLoc) return;
	
	    // Transition direction will change based on where in the site structure
	    // the current and next locations point to.
	
	    var _transitionDirection = (0, _transitionDirection3.default)(currLoc, nextLoc, this.state.articlePaths, this.state.chapterPaths),
	        isArticleTransition = _transitionDirection.isArticleTransition,
	        direction = _transitionDirection.direction;
	
	    this.setState({
	      isArticleTransition: isArticleTransition,
	      transitionNames: {
	        enter: _transitionsModule2.default["enter" + direction],
	        enterActive: _transitionsModule2.default["enterActive" + direction],
	        exit: _transitionsModule2.default["exit" + direction],
	        exitActive: _transitionsModule2.default["exitActive" + direction]
	      }
	    });
	  };
	
	  /**
	   * Used by <TransitionGroup> to allow components scheduled for exit to have
	   *  their transition styles changed.
	   *
	   * Full gory details available at: https://stackoverflow.com/questions/41404232/
	   */
	
	
	  Layout.prototype.transitionChildFactory = function transitionChildFactory(child) {
	    return _react2.default.cloneElement(child, {
	      classNames: this.state.transitionNames
	    });
	  };
	
	  Layout.prototype.getChildContext = function getChildContext() {
	    var _this4 = this;
	
	    return {
	      getEl: function getEl(Mask) {
	        _this4.setState({
	          MaskEl: _react2.default.cloneElement(Mask, {
	            style: _this4.maskStyles
	          })
	        });
	      }
	    };
	  };
	
	  Layout.prototype.render = function render() {
	    var _this5 = this;
	
	    var _props = this.props,
	        children = _props.children,
	        location = _props.location;
	    var _state = this.state,
	        chapters = _state.chapters,
	        MaskEl = _state.MaskEl,
	        isArticleTransition = _state.isArticleTransition;
	
	    var homeOverride = location.pathname === "/";
	    var shareImage = _sharingConfig2.default.shareImage;
	    var matchingArticlePaths = this.state.articlePaths.filter(function (path) {
	      return path.path == _this5.props.location.pathname;
	    });
	    var isArticle = matchingArticlePaths.length > 0;
	    var matchingChapterPath = this.state.chapterPaths.filter(function (path) {
	      return path.path == _this5.props.location.pathname;
	    });
	    var isChapter = matchingChapterPath.length > 0;
	
	    return _react2.default.createElement(
	      "div",
	      null,
	      _react2.default.createElement(
	        _LayoutHead2.default,
	        null,
	        _react2.default.createElement("meta", { property: "og:image", content: shareImage }),
	        _react2.default.createElement("meta", { property: "og:type", content: "website" }),
	        _react2.default.createElement("meta", { name: "og:title", content: "The State of European Tech 2017" }),
	        _react2.default.createElement("meta", { name: "twitter:card", content: "summary" }),
	        _react2.default.createElement("meta", { name: "twitter:site", content: "@atomico" }),
	        _react2.default.createElement("meta", { name: "twitter:creator", content: "@atomico" }),
	        _react2.default.createElement("meta", {
	          name: "twitter:title",
	          content: "The State of European Tech 2017"
	        }),
	        _react2.default.createElement("meta", { name: "twitter:image", content: shareImage }),
	        !isArticle && !isChapter && _react2.default.createElement("meta", {
	          name: "description",
	          content: "The State of European Tech 2017 is the deepest, data-led investigation into the European tech ecosystem."
	        }),
	        !isArticle && !isChapter && _react2.default.createElement("meta", {
	          name: "twitter:description",
	          content: "The State of European Tech 2017 is the deepest, data-led investigation into the European tech ecosystem - read it here."
	        }),
	        !isArticle && !isChapter && _react2.default.createElement("meta", {
	          name: "og:description",
	          content: "The State of European Tech 2017 is the deepest, data-led investigation into the European tech ecosystem"
	        })
	      ),
	      _react2.default.createElement(
	        "div",
	        { className: _indexModule2.default.shell },
	        _react2.default.createElement(_LayoutNav2.default, { chapters: chapters, currentPath: location.pathname }),
	        _react2.default.createElement(
	          _reactTransitionGroup.TransitionGroup,
	          {
	            className: _indexModule2.default.content,
	            childFactory: this.transitionChildFactory
	          },
	          _react2.default.createElement(
	            _reactTransitionGroup.CSSTransition
	            // Use location.key as it's always unique, even for identical pathnames
	            // Using location.pathname can cause transitions to break when repeatedly
	            // toggling between two screens
	            ,
	            { key: location.key,
	              timeout: { enter: 650, exit: 650 }
	            },
	            function (status) {
	              return _react2.default.createElement(
	                "div",
	                {
	                  className: _indexModule2.default.transitionHandler,
	                  style: homeOverride ? { overflowY: "scroll" } : {}
	                },
	                status === "entering" && isArticleTransition && _react2.default.createElement(
	                  Mask,
	                  null,
	                  MaskEl
	                ),
	                _react2.default.createElement(
	                  TransitionHandler,
	                  { location: location },
	                  children()
	                )
	              );
	            }
	          )
	        )
	      ),
	      _react2.default.createElement(_container4.default, null),
	      _react2.default.createElement(_container2.default, null),
	      homeOverride && _react2.default.createElement(_Banner2.default, null),
	      _react2.default.createElement("div", { id: "maskRoot" }),
	      _react2.default.createElement("div", { id: "buttonRoot" })
	    );
	  };
	
	  return Layout;
	}(_react.Component);
	
	Layout.childContextTypes = {
	  getEl: _propTypes2.default.func
	};
	
	Layout.propTypes = {
	  children: _propTypes2.default.func,
	  location: _propTypes2.default.shape({ pathname: _propTypes2.default.string }),
	  data: _propTypes2.default.shape({
	    allSoetChapterNode: _propTypes2.default.shape({
	      edges: _propTypes2.default.arrayOf(_propTypes2.default.shape({}))
	    }),
	    allSoetArticleNode: _propTypes2.default.shape({
	      edges: _propTypes2.default.arrayOf(_propTypes2.default.shape({}))
	    })
	  })
	};
	
	exports.default = (0, _withRouter2.default)(Layout);
	
	// eslint-disable-next-line no-undef
	
	var layoutQuery = exports.layoutQuery = "** extracted graphql fragment **";

/***/ }),

/***/ 622:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"shell":"src-layouts----index-module---shell---1jqyE","content":"src-layouts----index-module---content---1E5Fp","transitionHandler":"src-layouts----index-module---transitionHandler---2OEQO"};

/***/ }),

/***/ 623:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"enterDown":"src-layouts----transitions-module---enterDown---2Psbh","enterActiveDown":"src-layouts----transitions-module---enterActiveDown---2RjFi","exitDown":"src-layouts----transitions-module---exitDown---11IDI","exitActiveDown":"src-layouts----transitions-module---exitActiveDown---JgxHo","enterUp":"src-layouts----transitions-module---enterUp---2HJ-K","enterActiveUp":"src-layouts----transitions-module---enterActiveUp---1fUT9","exitUp":"src-layouts----transitions-module---exitUp---2nxdF","exitActiveUp":"src-layouts----transitions-module---exitActiveUp---1bkyW","enterRight":"src-layouts----transitions-module---enterRight---1KqjS","enterActiveRight":"src-layouts----transitions-module---enterActiveRight---1dDdc","exitRight":"src-layouts----transitions-module---exitRight---1a8qL","exitActiveRight":"src-layouts----transitions-module---exitActiveRight---jx7-9","enterLeft":"src-layouts----transitions-module---enterLeft---3etOS","enterActiveLeft":"src-layouts----transitions-module---enterActiveLeft---2fITa","exitLeft":"src-layouts----transitions-module---exitLeft---c2Lzx","exitActiveLeft":"src-layouts----transitions-module---exitActiveLeft---EV__S"};

/***/ }),

/***/ 505:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	/**
	 *
	 */
	var GATSBY_PATH_PREFIX = ("") || ""; // eslint-disable-line no-undef
	
	// Transition directions
	var DIR_DOWN = exports.DIR_DOWN = "Down";
	var DIR_LEFT = exports.DIR_LEFT = "Left";
	var DIR_RIGHT = exports.DIR_RIGHT = "Right";
	var DIR_UP = exports.DIR_UP = "Up";
	
	// Page types
	var T_ART = "article";
	var T_CHAP = "chapter";
	var T_HOME = "home";
	var T_OTHER = "other";
	
	/**
	 * Run a series of checks against the input values. Returns a transition
	 * direction.
	 *
	 * @param {*} current
	 * @param {*} next
	 */
	var getTransition = function getTransition(current, next) {
	  var direction = DIR_DOWN;
	
	  // Start with some hard-coded path checks, regardless of path types
	  var savedOverviewToDetail = current.path === "/saved/" && next.path === "/saved/article/";
	  if (savedOverviewToDetail) return DIR_LEFT;
	
	  var savedDetailToOverview = current.path === "/saved/article/" && next.path === "/saved/";
	  if (savedDetailToOverview) return DIR_RIGHT;
	
	  var filterOverviewToDetail = current.path === "/filter/" && next.path === "/filter/article/";
	  if (filterOverviewToDetail) return DIR_LEFT;
	
	  var filterDetailToOverview = current.path === "/filter/article/" && next.path === "/filter/";
	  if (filterDetailToOverview) return DIR_RIGHT;
	
	  var filterToSaved = current.path.startsWith("/filter/") && next.path.startsWith("/saved/");
	  if (filterToSaved) return DIR_UP;
	
	  var savedToFilter = current.path.startsWith("/saved/") && next.path.startsWith("/filter/");
	  if (savedToFilter) return DIR_DOWN;
	
	  // Continue with type and position based checks
	  var chapterToArticle = current.type === T_CHAP && next.type === T_ART;
	  var chapterToPrevArticle = chapterToArticle && current.index > next.chapterIndex;
	  if (chapterToPrevArticle) return DIR_UP;
	  if (chapterToArticle) return DIR_LEFT;
	
	  var articleToChapter = current.type === T_ART && next.type === T_CHAP;
	  var articleToNextChapter = articleToChapter && current.chapterIndex < next.index;
	  if (articleToNextChapter) return DIR_DOWN;
	  if (articleToChapter) return DIR_RIGHT;
	
	  var chapterToChapter = current.type === T_CHAP && next.type === T_CHAP;
	  var chapterToPrevChapter = chapterToChapter && current.index > next.index;
	  if (chapterToPrevChapter) return DIR_UP;
	  if (chapterToChapter) return DIR_DOWN; // If it's not up, it must be down
	
	  var articleToArticle = current.type === T_ART && next.type === T_ART;
	  var articleToPrevArticle = articleToArticle && current.index > next.index;
	  if (articleToPrevArticle) return DIR_UP;
	  if (articleToArticle) return DIR_DOWN; // If it's not up, it must be down
	
	  var anywhereToHome = next.type === T_HOME;
	  if (anywhereToHome) return DIR_UP;
	
	  var anywhereToOther = next.type === T_OTHER;
	  if (anywhereToOther) return DIR_DOWN;
	
	  var otherToAnywhere = current.type === T_OTHER && next.type !== T_OTHER;
	  if (otherToAnywhere) return DIR_UP;
	
	  return direction;
	};
	
	/**
	 * Given a path and arrays of sorted articlePaths and chapterPaths,
	 * categorise which section of the site the path belongs to.
	 *
	 * For article or chapter paths, calculate the path's index (aka position)
	 * within that category. e.g. the 10th article in the site.
	 *
	 * Article paths will also have their chapter index included, so we can detect
	 * later whether to apply a different transition to article <--> chapter
	 * path changes.
	 *
	 * articlePaths and chapterPaths shape:
	 *
	 * {
	 *   path: {string},
	 *   chapterId: {int} if a chapter - the chapter's id, if an article - the article's chapterId
	 * }
	 *
	 * @param {string} path
	 * @param {array} articlePaths an array of articlePath objects
	 * @param {array} chapterPaths an array of chapterPath objects
	 */
	var getPathTypeAndPosition = function getPathTypeAndPosition(path, articlePaths, chapterPaths) {
	  // Get position of path in either article or chapter paths
	  var articleIndex = articlePaths.findIndex(function (article) {
	    return path === article.path;
	  });
	  var chapterIndex = chapterPaths.findIndex(function (chapter) {
	    return path === chapter.path;
	  });
	
	  // path is an article?
	  if (articleIndex > -1) return {
	    type: T_ART,
	    index: articleIndex,
	    chapterIndex: chapterPaths.findIndex(
	    // find the index of this article's chapter
	    function (chapter) {
	      return chapter.chapterId === articlePaths[articleIndex].chapterId;
	    }),
	    path: path
	  };
	
	  // path is a chapter?
	  if (chapterIndex > -1) return {
	    type: T_CHAP,
	    index: chapterIndex,
	    path: path
	  };
	
	  if (path === "/") return { type: T_HOME, path: path }; // only one home page
	
	  return { type: T_OTHER, path: path }; // default if we don't match anything else
	};
	
	/**
	 * Run through a series of rules to work out direction the page transition
	 * should be.
	 *
	 * @param {string} currentPath The current path
	 * @param {string} nextPath The next path
	 * @param {array} articlePaths An array of objects describing paths
	 * @param {array} chapterPaths An array of objects describing paths
	 */
	// prettier-ignore
	var transitionDirection = function transitionDirection(currentPath, nextPath, articlePaths, chapterPaths) {
	  // Account for url prefixes
	  var unprefixedCurrentPath = currentPath.startsWith(GATSBY_PATH_PREFIX) ? currentPath.replace(GATSBY_PATH_PREFIX, "") : currentPath;
	
	  // Account for url prefixes
	  var unprefixedNextPath = nextPath.startsWith(GATSBY_PATH_PREFIX) ? nextPath.replace(GATSBY_PATH_PREFIX, "") : nextPath;
	
	  var current = getPathTypeAndPosition(unprefixedCurrentPath, articlePaths, chapterPaths);
	  var next = getPathTypeAndPosition(unprefixedNextPath, articlePaths, chapterPaths);
	
	  return {
	    isArticleTransition: current.type === T_ART && next.type === T_ART,
	    direction: getTransition(current, next)
	  };
	};
	exports.default = transitionDirection;

/***/ })

});


// WEBPACK FOOTER //
// component---src-layouts-index-js-33edfedfde00b5ac0da8.js